/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <div :key="keyToUpdate">
    <custom-per-page v-if="openCustomPaginationModal" @updatePerPageValue="updatePerPageValue" @close="openCustomPaginationModal = false;"></custom-per-page>
    <customAlertMessage v-if="enableCustomMessage" v-bind="alertMessageProperties" @close="enableCustomMessage = false"></customAlertMessage>
    <OCBrowse v-if="enableOICBrowse" @close="closeOCBrowser()" @traverToCatalog="setRouterUrl" :pIPList="parentIPList"></OCBrowse>
    <div v-if="vdialogComponents.includes(openTagMetadataModel)">
      <component
        :is="openTagMetadataModel"
        v-bind="currentProperties"
        v-if="!isMetadataView && isMetadataManagerVisible"
        :headerName="openTagMetadataModel == 'set-user-dialog'?'Set User':''"
        @close="closeModal"
        @closeUserAddition="closeUserAddition"
        @openSubclipWindow="openSubclipWindow"
        @openVideoTranscriptWindow="openVideoTranscriptWindow"
        @assetSelectionUpdated="handleAssetVersionUpdate"
        @handleFilesBrowse="handleFusionBrowsedFiles"
        @uploadSvgIconAsCover="uploadSvgIconAsCover"
        :ref="'modal'+openTagMetadataModel"
      ></component>
    </div>
    <div v-else-if="!isMetadataView">
      <router-view
        :name="openTagMetadataModel"
        v-bind="currentProperties"
        v-if="isMetadataManagerVisible"
        @close="closeModal"
        @openSubclipWindow="openSubclipWindow"
        @openVideoTranscriptWindow="openVideoTranscriptWindow"
        @assetSelectionUpdated="handleAssetVersionUpdate"
        :ref="'modal'+openTagMetadataModel"
        @AIComponentNavigation="traverseToAIComp"
      ></router-view>
    </div>


    <!-- <sub-clips-manager v-if="openSubclips" v-bind="currentProperties" @close="closeSubclip"></sub-clips-manager> -->
    <departmentsCommonComponent ref="departmentsComponent" v-if="barcodeInfoFromStartup.enable_department" :updateDepartments="updateDepartments" :inWorkspace="true" @updatedSelectedProjectsArr="updatedSelectedProjectsArr" @unsetUpdateDepartmentsFlag="updateDepartments = false"></departmentsCommonComponent>
    <template v-if="isMetadataView">
        <MetadataView :style="setHeightOfMetadataView()" @AIComponentNavigation="traverseToAIComp"
          @changeJobsPanelState="changeJobsPanelState"
          @columns-updated="handleMetadataViewColumnsUpdated"
          :assets-from-parent="assetsList"
          :children-from-parent="children"
          :getCookieValueOfJobPanel="getCookieValueOfJobPanel"
          :isAdvancedSearchEnabled="isAdvancedSearchEnabled" 
          :isMetadataView="isMetadataView"
          :rootCatalogInfo="rootCatalogInfo"
          :rootPathPermission="rootPathPermission"
          :viewType="viewType"
          :workspace="workspace"
          :totalAssetsFromParent="totalAssets"
          :assetsPerpageFromParent="assetsPerpage"
          :pageFromParent="page"
          :selectedFileInfoFromParent="selectedFileInfo"
          :isNLPSearchMode="isNLPSearchMode"
          @update-totalAssetsFromParent="totalAssets = $event"
          @update-assetsPerpageFromParent="assetsPerpage = $event"
          @update-children-from-metadata="children = $event"
          @update-assets-from-parent="assetsList = $event"
          @update-pageFromParent="page = $event"
          :isActiveAssetFromParent="isActive"
         :catalogSelected="catalogSelected" :basicAssetInfo="basicAssetInfo" @showContextMenu="show" :refreshFileInfoAndShowAsset="refreshFileInfoAndShowAsset"></MetadataView>
    </template>

    <template v-else>
      <top-nav
      @changeComponent="changeComponent"
      @changeDirectoryFromUrl="changeCatalog"
      :getCookieValueOfJobPanel="getCookieValueOfJobPanel"
      compoentType="CatalogWorkspace"
      :usedBy="workspace && workspace == 'Projects'?rootCatalogInfo.catalog_name:'Catalogs'"
      :dirs="dirs"
      ref="top_nav_bar"
      :sortedOption="sortBy"
      v-on:sort-by-filter-updated="sortCatalogTable"
      @fileStateFilterUpdated="updateFileStateFilter"
      @reloadThePage="reloadThePage"
      @changeJobsPanelState="changeJobsPanelState"
      :workspace="workspace"
      :rootCatalogInfo="rootCatalogInfo"
      @columns-updated="handleColumnsUpdated"
    ></top-nav>
    <div
      class="assets-view-wrapper"
      :class="{ 'thumbnail-view-mode': viewType == true, 'list-view-mode': viewType == false }"
      @click="deselectFileAndContextMenu"
      @contextmenu.stop.prevent="show($event, selectedFileInfo)"
      :style="getAdjustedTableHeightStyle()"
      :ripple="false"
      data-app
    >
      
      <div v-if="children.filter(op=>(!('catalog_type' in op) || (!['photo_album','package'].includes(op.catalog_type)))).length && viewType == true"
            class="text-left"
            style="padding: 10px 0px 0px 20px; color: #777"
          >
          <svg  v-if="!showCatalogs" v-on:click.stop.prevent="showCatalogs = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
            <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
          </svg>
          <svg v-if="showCatalogs" v-on:click.stop.prevent="showCatalogs = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
            <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg>
            {{$t('Catalogs')}}
          </div>
      <ul v-if="showCatalogs && viewType == true && children.filter(op=>(!('catalog_type' in op) || (!['photo_album','package'].includes(op.catalog_type)))).length"
        class="thumbnail-view-ul folder-view-ul">
        <drag-select-container name="drag-select-container" style="display:contents" attribute="attr" @change="dragSelect($event)">
        <li
          class="folder-view-li"
          v-for="catalog in children.filter(op=>(!('catalog_type' in op) || (!['photo_album','package'].includes(op.catalog_type))))"
          :key="catalog._id"
          :attr="catalog._id"
          @click.exact="selectElement($event,catalog)"
          :class="{ activeCatalog: isFileSelected(catalog) , 'reduce-opacity': catalog.asset_state == 'MARK FOR DELETE'}"
          @click.ctrl="multiSelectElemet(catalog)"
          @click.meta="multiSelectElemet(catalog)"
          @dblclick="showCatalogDetails(catalog)"
          @contextmenu.stop.prevent="show($event, catalog)"
          :ripple="false"
          :title="catalog.catalog_name"
          data-app
          >
          <!-- <div @contextmenu="show($event, bin)" :ripple="false" data-app> -->
          <div class="folder-view" :class="catalog.asset_state == 'MARK FOR DELETE'?'reduce-opacity':' '">
              <template v-if="'catalog_cover_photo_path' in catalog && catalog.catalog_cover_photo_path.trim().length > 0">
                <div class="card" style="width: 34px; height: 78%; top:6px; overflow: hidden; display: flex; background-color: transparent;border-radius: 7px;">
                  <img class="card-img-top" :src="getCatalogCoverPhoto(catalog)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;background-color: transparent">
                </div>
              </template>
              <div v-else-if="'catalog_cover_photo_file_uid' in catalog && catalog.catalog_cover_photo_file_uid.trim().length > 0 && catalog.catalog_cover_photo_file_uid.startsWith('svg-')" style="height: 30px;width: 30px;" v-html="getSvgIconForCoverPhoto(catalog.catalog_cover_photo_file_uid.split('svg-')[1])"></div>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#5f777d" class="bi bi-folder-fill" viewBox="0 0 16 16">
                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
              </svg>
            <img v-if="catalog.asset_state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;inset-inline-end :50%;">
          </div>
          <div class="catalogs-data">
            {{ catalog.catalog_name }}
          </div>
          <!-- </div> -->
        </li>
        </drag-select-container>
      </ul>
      <div v-if="children.filter(op=>('catalog_type' in op && op.catalog_type == 'photo_album')).length && viewType == true"
        class="text-left" style="padding: 10px 0px 0px 20px; color: #777">
        <svg  v-if="!showAlbums" v-on:click.stop.prevent="showAlbums = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
          <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
        </svg>
        <svg v-if="showAlbums" v-on:click.stop.prevent="showAlbums = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
          <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
        </svg>
        {{$t('Photo Albums')}}
      </div>
      <ul v-if="showAlbums && viewType == true && children.filter(op=>('catalog_type' in op && op.catalog_type == 'photo_album')).length"
        class="thumbnail-view-ul folder-view-ul" style="overflow: unset;">
        <drag-select-container name="drag-select-container" style="display:contents" attribute="attr" @change="dragSelect($event)">
        <li
          v-for="catalog in children.filter(op=>('catalog_type' in op && op.catalog_type == 'photo_album'))"
          :key="catalog._id"
          :attr="catalog._id"
          @click.exact="selectElement($event,catalog)"
          :class="{ activeCatalog: isFileSelected(catalog) , 'reduce-opacity': catalog.asset_state == 'MARK FOR DELETE'}"
          @click.ctrl="multiSelectElemet(catalog)"
          @click.meta="multiSelectElemet(catalog)"
          @dblclick="showCatalogDetails(catalog)"
          @contextmenu.stop.prevent="show($event, catalog)"
          :ripple="false"
          :title="catalog.catalog_name"
          data-app
          style="position: relative;height:auto;width:auto;padding-inline-start:0px"
          >
          <div class="asset-thumbnail" style="height: 200px !important;width: 174px !important;margin-top:0px">
          <div class="card" style="width: 172px; height: 100%; overflow: hidden; display: flex; background-color: rgb(45, 57, 60); border: 1px solid rgb(58, 58, 58);border-radius: 7px;">
            <img class="card-img-top" :src="getCatalogCoverPhoto(catalog)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;">
            <div class="card-body" style="width: inherit; display: flex; align-items: center; padding: 0px 7px 0px 7px; position: absolute; height: 45px; background-color: rgba(3, 4, 4, 0.7);border-radius: 0px 0px 7px 7px;bottom:0px">
              <div style="width:100%;display:inline-block;text-align:start">
                <div style="overflow: hidden;text-overflow: ellipsis;" :title="catalog.catalog_name">
                  <div  v-if="catalog.highlight && catalog.highlight['catalog_name']" class="transcript-content-wrapper"
                   style="display:flex;width: 100%; align-items: flex-start;">
                    <div style="flex: 1;">
                      <span v-for="(cContent,index) in catalog.highlight['catalog_name']" :key="'catalog_name'+index" v-html="getTranscriptHighlightContent(cContent)"  class="transcript-content-highlight" style="white-space: pre-wrap;"></span>
                    </div>
                  </div>
                  <span v-else>{{catalog.catalog_name}}</span>
                </div>
                <div style="width:100%;font-size: 12px;display:inline-flex;color:#adadad">
                  <template v-if="'album_assets_count' in catalog && catalog.album_assets_count > 0">
                    <div v-if="catalog.album_assets_count > 1" style="width:50%">{{catalog.album_assets_count}} {{$t('files')}}</div>
                    <div v-else-if="catalog.album_assets_count <= 1" style="width:50%">{{catalog.album_assets_count}} {{$t('file')}}</div>
                  </template>
                  <div v-else style="width:50%">0 {{$t('files')}}</div>
                  <div style="width:50%;text-align:end" :title="getDateAndTimeInConfiguredFormat(catalog.created_datetime? catalog.created_datetime:catalog.asset_created_datetime)">{{getDateAndTimeInConfiguredFormat(catalog.created_datetime? catalog.created_datetime:catalog.asset_created_datetime, true)}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="catalog.asset_state == 'GROWING'">
            <img :src="growingFileGif"
                  alt="loading"
                  style="height:50px;width:65px;position:absolute;bottom:40%;inset-inline-start:28%"
                />
          </div>
          <div v-else-if="catalog.state == 'ERROR'">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#af0000" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16" style="position:absolute;bottom:49%;inset-inline-start:41%">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
              <title>{{$t('ERROR')}}</title>
            </svg>
          </div>
          <div v-else-if="catalog.asset_state == 'MARK FOR DELETE'">
            <img
              :src="markForDeleteIcn"
              alt="markfordelete"
              style="height:25px;width:29px;position:absolute;bottom:47%;inset-inline-start:42%"
              />
          </div>
          <div v-if="eOMenu || !['GROWING'].includes(catalog.asset_state)"
              class="shortcut-actions-type-icons-wrapper" style="z-index:2;" :class="eOMenu?'overWriteShortcutIconWrapper':''">
            <div class="overflow-parent-div">
              <svg @click.stop.prevent="eOMenu=true;selectElement($event,catalog,false);show($event, selectedFileInfo)" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                <title>{{$t('More actions')}}</title>
                <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
              </svg>
            </div>
          </div>
        </div>
        </li>
        </drag-select-container>
      </ul>
      <div v-if="children.filter(op=>(('catalog_type' in op) && (['package'].includes(op.catalog_type)))).length && viewType == true"
            class="text-left"
            style="padding: 10px 0px 0px 20px; color: #777"
          >
        <svg  v-if="!showPackages" v-on:click.stop.prevent="showPackages = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
          <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
        </svg>
        <svg v-if="showPackages" v-on:click.stop.prevent="showPackages = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
          <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
        </svg>
          {{$t('Packages')}}
      </div>
      <ul v-if="showPackages && viewType == true && children.filter(op=>(('catalog_type' in op) && (['package'].includes(op.catalog_type)))).length"
        class="thumbnail-view-ul folder-view-ul">
        <drag-select-container name="drag-select-container" style="display:contents" attribute="attr" @change="dragSelect($event)">
        <li
          class="folder-view-li"
          v-for="catalog in children.filter(op=>(('catalog_type' in op) && (['package'].includes(op.catalog_type))))"
          :key="catalog._id"
          :attr="catalog._id"
          @click.exact="selectElement($event,catalog)"
          :class="{ activeCatalog: isFileSelected(catalog) , 'reduce-opacity': catalog.asset_state == 'MARK FOR DELETE'}"
          @click.ctrl="multiSelectElemet(catalog)"
          @click.meta="multiSelectElemet(catalog)"
          @dblclick="showCatalogDetails(catalog)"
          @contextmenu.stop.prevent="show($event, catalog)"
          :ripple="false"
          :title="catalog.catalog_name"
          data-app
          >
          <!-- <div @contextmenu="show($event, bin)" :ripple="false" data-app> -->
          <div class="folder-view" :class="catalog.asset_state == 'MARK FOR DELETE'?'reduce-opacity':' '">
              <template v-if="'catalog_cover_photo_path' in catalog && catalog.catalog_cover_photo_path.trim().length > 0">
                <div class="card" style="width: 34px; height: 78%; top:6px; overflow: hidden; display: flex; background-color: transparent;border-radius: 7px;">
                  <img class="card-img-top" :src="getCatalogCoverPhoto(catalog)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;background-color: transparent">
                </div>
              </template>
              <div v-else-if="'catalog_cover_photo_file_uid' in catalog && catalog.catalog_cover_photo_file_uid.trim().length > 0 && catalog.catalog_cover_photo_file_uid.startsWith('svg-')" style="height: 30px;width: 30px;" v-html="getSvgIconForCoverPhoto(catalog.catalog_cover_photo_file_uid.split('svg-')[1])"></div>
              <!-- <svg v-else xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#5f777d" class="bi bi-folder-fill" viewBox="0 0 16 16">
                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
              </svg> -->
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#5f777d" class="bi bi-collection-fill" viewBox="0 0 16 16">
                <path d="M0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6zM2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3m2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1"/>
              </svg>
            <img v-if="catalog.asset_state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;inset-inline-end :50%;">
          </div>
          <div class="catalogs-data">
            {{ catalog.catalog_name }}
          </div>
          <!-- </div> -->
        </li>
        </drag-select-container>
      </ul>
      <div v-if="assetsList != undefined && assetsList.length == 0 && children.length == 0">
        <div style="font-size: 20px; margin-top: 8%; color: #686868">
          {{ $t('No Files Found') }}
        </div>
      </div>
      <div v-else class="file-table-container">
        <ul v-if="viewType == true && assetsList.length > 0" class="thumbnail-view-ul common-view-ul" :style="thumbnailCardStyle" :class="{ 'thumbnail-fill': thumbnailScale === 'fill' }" style="display: flex;flex-direction: column;">
          <div style="display: flex;justify-content: flex-start;align-items: center;">
            <input v-on:change.stop="selectAllFiles" v-model='allFilesSelected' type="checkbox" class="text-light bigger-checkboxes" style="position: relative;top: 3px;">
            <div 
              class="text-left"  style="padding: 10px 0px 0px 10px; color: #777">
              <svg  v-if="!showFiles" v-on:click.stop.prevent="showFiles = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
              </svg>
              <svg v-if="showFiles" v-on:click.stop.prevent="showFiles = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg>
              {{$t('Files')}}
              <!-- {{"Files ( " + totalAssetsDisplay(totalAssets) + " )"}} -->
            </div>
          <!-- <div style="padding: 10px 20px 0px 0px;display: flex;align-items: center;">
            <label for="select_all_files_checkbox"  class="mb-0">Select all</label></div> -->
        </div>
        <template v-if="showFiles">
          <drag-select-container name="drag-select-container" class="file-card-container" style="display: flex;flex-wrap: wrap;" attribute="attr" @change="dragSelect($event)">
          <li
            v-for="file in assetsList"
            :key="file._id"
            :attr="file._id"
            @click.exact="selectElement($event,file)"
            @click.ctrl="multiSelectElemet(file)"
            @click.meta="multiSelectElemet(file)"
            @dblclick="showAssetDetails(file)"
            :class="{ activeCatalog: isFileSelected(file) }"
            @contextmenu.stop.prevent="show($event, file)" :ripple="false" data-app
            style="position:relative"
            :title="getFileName(file)"
            @mousemove="handleMouseMoveForStoryBoardPreview($event,file)"
            @mouseleave="storyboardPreviewActiveId = null"
          >
            <div class="asset-thumbnail" ref="thumbnailwrapper" :data-thumbnailwrapperid="file._id">
              <StoryBoardImagePreview :ref="'storyboard'+file._id" v-if="getFileMimeType(file) == 'video' && storyboardPreviewActiveId == file._id" :assetDetails="file"></StoryBoardImagePreview>
              <div class="thumbnail-view" style="position: relative;align-items: center;display: inline-flex;justify-content:center" :class="file.asset_state == 'MARK FOR DELETE' || file.state == 'ERROR'?'reduce-opacity':' '">
                <img :src="getThumbnailPath(file,'FOR_SVG_THUMBNAIL')" @error="(e) => replaceByDefaultImage(e,file,'FOR_SVG_THUMBNAIL')" @load="updateFallbackThumbnailStyle($event, file)" alt="image" draggable="false" />
              </div>
              <div v-if="'mime_type' in file && file.mime_type && (file.mime_type.startsWith('video') || file.mime_type.startsWith('audio')) && 'duration' in file && file.duration"
                      class="comm-thumbnail-view-duration-label">
                      {{getHumanReadableDuration(file.duration)}}
              </div>
              <div v-if='checkIfDisabled(file)' :id="'assetResolution_'+file._id" class="thumbnail-view-resolution-label">
                    {{ getReadableResolutionValue(file) }}
              </div>
              <div class="storage-type-icons-wrapper" v-if="(file.storage_class != undefined && file.storage_class.length)|| file.asset_type == 'subclip' || file.subclips_present == true || (Object.keys(file).includes('asset_ttl') && file.asset_ttl) || (file.location_info && (Object.keys(file.location_info).includes('alto') || Object.keys(file.location_info).includes('gravity_deep'))) || 'lock' in file"  :style="file.asset_type == 'subclip'?'min-width:40px;':''">
                  <template v-if="file.asset_state != 'MARK FOR DELETE' &&  Object.keys(file).includes('asset_ttl') && file.asset_ttl">
                    <div v-if="loadTTLIcons(file.asset_ttl)" v-html="loadTTLIcons(file.asset_ttl)" style="width: 22px;"></div>
                  </template>
                  <svg v-if="file.subclips_present == true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                    <title>Have subclips</title>
                  </svg>
                  <svg v-if="'asset_lock' in file && file.asset_lock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18" height="18" style="position: relative;top: -1px;">
                    <path fill="#cdcdcd" d="M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z" style=""></path>
                    <path fill="#e98405" d="M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z" style=""></path>
                    <path fill="#55524e" d="M24 28A3 3 0 1 0 24 34A3 3 0 1 0 24 28Z" style=""></path>
                    <title>{{$t('Locked')}}</title>
                  </svg>
                  <div v-if="file.asset_type == 'subclip'" style="position:relative;inset-inline-start:4px;width:30px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16">
                      <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                      <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                      <title>Subclip</title>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;">
                      <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                      <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                      <title>Subclip</title>
                    </svg>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                    <title>Amazon S3 Glacier</title>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Deep Archive')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                    <title>Amazon S3 Glacier Deep Archive</title>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Instant Retrieval')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                    <title>Amazon S3 Glacier Instant Retrieval</title>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Standard')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                    <title>Amazon S3 Standard</title>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" v-if="Object.keys(file).includes('archived') && file.archived" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16">
                    <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                    <title>Archived</title>
                  </svg>
                  <template v-if="'location_info' in file && 'gravity_deep' in file.location_info">
                    <div v-for="cId of file.location_info.gravity_deep.container_ids" :key="cId">
                      <svg v-if="cId == 'CACHE'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-c-square" viewBox="0 0 16 16">
                        <title>{{ cId }}</title>
                        <path d="M8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"/>
                        <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"/>
                      </svg>
                      <svg v-else-if="cId && cId.startsWith('Tape')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cassette-fill" viewBox="0 0 16 16">
                        <title>{{ cId }}</title>
                        <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h.191l1.862-3.724A.5.5 0 0 1 4 10h8a.5.5 0 0 1 .447.276L14.31 14h.191a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z"/>
                        <path d="m13.191 14-1.5-3H4.309l-1.5 3h10.382Z"/>
                      </svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hdd-fill" viewBox="0 0 16 16">
                        <title>{{ cId }}</title>
                        <path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>
                      </svg>
                    </div>
                  </template>
                  <img v-if="file.location_info && Object.keys(file.location_info).includes('alto')" title="ALTO" :src="altoLogo" alt="alto"/>
              </div>
              <div v-if="eOMenu || !['GROWING'].includes(file.state)"
                           class="shortcut-actions-type-icons-wrapper" style="z-index:2;" :class="eOMenu?'overWriteShortcutIconWrapper':''">

                <template v-if="!['MARK FOR DELETE'].includes(file.state) &&
                                  !['no-access','browse'].includes(file.permissions) &&
                                  (Object.keys(selectedFileInfo).length >= 1 || Object.keys(selectedFiles).length == 1 ||
                                        Object.keys(selectedFileInfo).length <= 0 && Object.keys(selectedFiles).length <= 0 ||
                                          !isFileSelected(file))">
                  <svg v-if="!lockRestrictedAction('Download', file) && isFileActionEnabled('Download',file.permissions)" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                    <title>{{$t('Download')}}</title>
                    <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                    <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                  </svg>
                  <svg v-if="!lockRestrictedAction('Chat', file) && file.asset_type == 'subclip' && isFileActionEnabled('Chat',file.permissions)" xmlns="http://www.w3.org/2000/svg" @click="shareInChatSubclips(file)" width="16" height="16" fill="currentColor" class="bi bi-chat-dots-fill" viewBox="0 0 16 16">
                    <title>{{$t('Share in chat')}}</title>
                    <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                  </svg>
                  <svg v-if="!lockRestrictedAction('Share', file) && file.asset_type != 'subclip' && isFileActionEnabled('Share',file.permissions)" @click="handleShareAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-share-fill" viewBox="0 0 16 16">
                    <title>{{$t('Share')}}</title>
                    <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                  </svg>
                  <svg v-if="(!lockRestrictedAction('tag-metadata', file) || !lockRestrictedAction('tag-metadata-requestor', file)) && (isFileActionEnabled('tag-metadata',file.permissions) || isFileActionEnabled('tag-metadata-requestor',file.permissions))" @click="handleTagMetadataAssetHoverAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-tag-fill" viewBox="0 0 16 16">
                    <title>{{$t('Tag Metadata')}}</title>
                    <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                  </svg>
                </template>
                <svg v-if="!lockRestrictedAction('Preview', file)" @click="showAssetDetails(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                    <path d="M0 0h24v24H0V0z" fill="none"/>
                    <title>{{$t('Preview')}}</title>
                    <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                </svg>
                <div class="overflow-parent-div">
                  <svg @click.stop.prevent="eOMenu=true;selectElement($event,file,false);show($event, selectedFileInfo)" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                    <title>{{$t('More actions')}}</title>
                    <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                  </svg>
                  <!-- <template v-if="eOMenu">
                    <div style="display:block">
                       <div class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                          <div class="dropdown-item p-2 copy-link-action" @click="setClipBoardText(file)" title="Copy link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fdfff4" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                            </svg>
                            Copy link</div>
                          <div v-if="isEnabled('Chat')" class="dropdown-item p-2 copy-link-action" @click="openShareInChat()" title="">
                            <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-share-fill" viewBox="0 0 16 16">
                              <title></title>
                              <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                            </svg>
                            Share in chat
                          </div>
                          <template v-for="menu of getContextMenuItems(selectedFileInfo, 'DEFAULT', false)">
                            <div class="dropdown-item p-2 copy-link-action hover-context-menu-action" :title="menu.action_name" :key="menu.action_name">
                              <svg class="svg-hover-context-menu-icon" fill="currentColor"  v-html="getHoverMenuActionIcon(menu.action_name)"> </svg>
                              <span>{{menu.label}}</span>
                            </div>
                          </template>
                        </div>
                      </div>
                  </template> -->
                </div>
              </div>
            </div>
            <div class="thumbnail-data d-inline-flex" style="float:inline-start;width:100%">
              <div v-html="getSvgIconsOfMediaTypes(file)" class="svg-icons-display"></div>
              <div class="file-name" :title="getFileName(file)" v-if="!getHighlightFilename(file,getFileName(file)).highlight" :style="barcodeInfoFromStartup.enable_file_extension?'':'max-width:140px !important'" style="display:flex">
                <span class="dynamic-slug-name">{{ getFileName(file) }}</span>
                <span class="file-extension-thumbnail-view" v-if="barcodeInfoFromStartup.enable_file_extension && file.mime_type" :title="file.mime_type.split('/')[1]">.{{file.mime_type.split('/')[1]}}</span>
              </div>
              <div class="file-name" :title="getFileName(file)" v-else :style="barcodeInfoFromStartup.enable_file_extension?'':'max-width:140px !important'" style="display:flex;">
                <span class="dynamic-slug-name" v-html="getHighlightFilename(file,getFileName(file)).slugname"></span>
                <span class="file-extension-thumbnail-view" v-if="barcodeInfoFromStartup.enable_file_extension && file.mime_type" :title="file.mime_type.split('/')[1]">.{{file.mime_type.split('/')[1]}}</span>
              </div>
            </div>
            <div v-if="file.state == 'GROWING' || file.asset_state == 'GROWING'">
              <img
                :src="growingFileGif"
                alt="loading"
                style="height:50px;width:65px;position:absolute;bottom:44%;left:50%;transform:translateX(-50%);"
              />
            </div>
            <div v-else-if="file.state == 'ERROR'">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#af0000" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16" style="position:absolute;bottom:49%;inset-inline-start:41%">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                    <title>{{$t('ERROR')}}</title>
                </svg>
            </div>
            <div v-else-if="file.asset_state == 'MARK FOR DELETE'">
              <img
                :src="markForDeleteIcn"
                alt="markfordelete"
                style="height:25px;width:29px;position:absolute;bottom:47%;inset-inline-start:42%"
              />
            </div>
            <!-- <div v-html="getMediaTypeIcons(file.mime_type)" style="position:absolute;bottom:42%;inset-inline-start:36%"></div> -->
          </li>
          </drag-select-container>
        </template>
        </ul>
        
        <div
          class="list-view-wrapper"
          :class="{ 'dock-open-list-view': isDockPanelOpen() }"
          v-if="viewType == false"
          @click="deselectFileAndContextMenu"
          @contextmenu.stop.prevent="show($event, selectedFileInfo)"
          :ripple="false"
          data-app
        >
          <div class="metadata-table-scroll-wrapper" :class="{ 'no-configured-columns': !enabledMetadataColumns || !enabledMetadataColumns.length }">
            <table
                ref="catalogListTable"
                class="tabletable-with-border table-scroll small-first-col table-cell-styles metadata-config-table"
                :class="{ resizing: isResizingColumn }"
                :style="isDockPanelOpen()
                  ? { width: '100%', minWidth: '100%', maxWidth: '100%', tableLayout: 'fixed' }
                  : getResizableTableStyle()"
              >
              <colgroup>
                <template v-if="isDockPanelOpen()">
                  <col style="width: 140px">
                  <col style="width: auto">
                </template>
              
                <template v-else>
                  <col :style="{ width: getNormalListColumnWidth('preview') }">
                  <col :style="{ width: getNormalListColumnWidth('slugname') }">
                  <col :style="{ width: getNormalListColumnWidth('created_datetime') }">
                  <col :style="{ width: getNormalListColumnWidth('added_datetime') }">
                  <col :style="{ width: getNormalListColumnWidth('size') }">
                
                  <col
                    v-for="column in enabledMetadataColumns"
                    :key="'col_' + column._id"
                    :style="{ width: getNormalListColumnWidth(column._id, true) }"
                  >
                </template>
              </colgroup>
              <thead>
                <tr style="height:40px !important">
                  <!-- <th style="width:2%">
                    <td>
                      <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" v-model="allSelected"/>
                    </td>
                  </th> -->
                  <th class="asset-preview-col">
                    <div class="metadata-header-cell preview-header-cell">
                      <span class="resize-handle" @mousedown.stop.prevent="startColumnResize($event, 'preview')"></span>
                    </div>
                  </th>

                  <th class="slugname-header-col" style="text-align:start;">
                    <div class="metadata-header-cell slugname-header-cell" style="justify-content:flex-start">
                      <span>{{$t("Slugname")}}</span>
                      <span class="resize-handle" @mousedown.stop.prevent="startColumnResize($event, 'slugname')"></span>
                    </div>
                  </th>
                  
                  <th class="date-created-col" v-if="!isDockPanelOpen()">
                    <div class="metadata-header-cell" style="justify-content:center">
                      <span>{{$t("Date Created")}}</span>
                      <span class="resize-handle" @mousedown.stop.prevent="startColumnResize($event, 'created_datetime')"></span>
                    </div>
                  </th>
                  
                  <th class="date-added-col" v-if="!isDockPanelOpen()">
                    <div class="metadata-header-cell" style="justify-content:center">
                      <span>{{$t("Date Added")}}</span>
                      <span class="resize-handle" @mousedown.stop.prevent="startColumnResize($event, 'added_datetime')"></span>
                    </div>
                  </th>
                  
                  <th class="size-col" v-if="!isDockPanelOpen()">
                    <div class="metadata-header-cell" style="justify-content:flex-end;padding-right:10px">
                      <span>{{$t("Size")}}</span>
                      <span class="resize-handle" @mousedown.stop.prevent="startColumnResize($event, 'size')"></span>
                    </div>
                  </th>
                  
                  <template v-if="!isDockPanelOpen()">
                    <th
                      v-for="column in enabledMetadataColumns"
                      :key="'metadata_header_' + column._id"
                      class="metadata-config-header-cell"
                      :class="{ 'metadata-multiline-th': column.type === 'FREETEXT_MULTILINE' }"
                    >
                      <div
                        class="metadata-header-cell"
                        :class="{ 'metadata-multiline-header-cell': column.type === 'FREETEXT_MULTILINE' }"
                      >
                        <span>{{ column.name }}</span>
                        <span
                          class="resize-handle"
                          @mousedown.stop.prevent="startColumnResize($event, column._id)"
                        ></span>
                      </div>
                    </th>
                  </template>
                  <!-- <th style="width:10%;text-align:center" v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible">Type</th> -->
                </tr>
              </thead>
              <tbody>
                <template v-if="children.filter(op=>(!('catalog_type' in op) || (!['photo_album','package'].includes(op.catalog_type)))).length">
                  <tr class="metadata-section-row">
                    <td colspan="999">
                  <div v-if="children.filter( op=>(!('catalog_type' in op) || (!['photo_album','package'].includes(op.catalog_type)))).length"
                    class="text-left" style="padding: 10px 0px 0px 20px; color: #777;margin: 11px;">
                    <svg  v-if="!showCatalogsInListView" v-on:click.stop.prevent="showCatalogsInListView = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                      <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                    </svg>
                    <svg v-if="showCatalogsInListView" v-on:click.stop.prevent="showCatalogsInListView = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                      <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                    </svg>
                      {{$t('Catalogs')}}
                  </div>
                    </td>
                  </tr>
                  <template v-if="showCatalogsInListView">

                  <drag-select-container name="drag-select-container" style="display:contents" attribute="attr" @change="dragSelect($event)">
                    <template  v-for="catalog in children.filter(op=>(!('catalog_type' in op) || (!['photo_album','package'].includes(op.catalog_type))))">
                      <tr :key="catalog._id"
                          :attr="catalog._id" 
                          @click.exact="selectElement($event,catalog)"
                          @dblclick="showCatalogDetails(catalog,'list-view')"
                          class="active-list-view"
                          :class="{ activeAsset: isFileSelected(catalog), 'reduce-opacity': catalog.asset_state == 'MARK FOR DELETE' }"
                          @click.ctrl="multiSelectElemet(catalog)"
                          @click.meta="multiSelectElemet(catalog)"
                          @contextmenu.stop.prevent="show($event, catalog)"
                          :ripple="false" 
                          data-app
                          style="vertical-align: middle;"
                          >
                          <td>
                            <StoryBoardImagePreview :ref="'storyboard'+catalog._id" v-if="getFileMimeType(catalog) == 'video' && storyboardPreviewActiveId == catalog._id" :assetDetails="catalog"></StoryBoardImagePreview>
                            <div v-if="'catalog_cover_photo_path' in catalog && catalog.catalog_cover_photo_path.trim().length > 0"
                              style="display: flex;justify-content: center;height: 40px !important;">
                              <div class="card" style="width: 39px; height: 100%; overflow: hidden; display: flex; background-color: transparent;border-radius: 7px;"
                              :style="catalog.asset_state == 'MARK FOR DELETE'?'inset-inline-start:9px;':''">
                                <img class="card-img-top" :src="getCatalogCoverPhoto(catalog)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap"   style="
                                background-color: transparent;
                                width: 100% !important;
                                height: 100% !important;
                                max-width: 100% !important;
                                max-height: 100% !important;
                                object-fit: cover !important;
                                display: block !important;
                              ">
                              </div>
                              <img v-if="catalog.asset_state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;inset-inline-end :15%;top:24px;">
                            </div>
                            <div v-else-if="'catalog_cover_photo_file_uid' in catalog && catalog.catalog_cover_photo_file_uid.trim().length > 0 && catalog.catalog_cover_photo_file_uid.startsWith('svg-')" style="height: 30px;width: 30px;margin: auto;" v-html="getSvgIconForCoverPhoto(catalog.catalog_cover_photo_file_uid.split('svg-')[1])"></div>
                            <div v-else>
                              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#858585" class="bi bi-folder-fill" viewBox="0 0 16 16" style="position: relative;inset-inline-start :-1px;">
                                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                              </svg>
                              <img v-if="catalog.asset_state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;inset-inline-end :15%;top: 2px;">
                            </div>
                          </td>
                          <td class="comm-lengthy-value-styles slugname-list-cell" style="text-align:start" :title="catalog.dir_name"> <!-- @mousedown -->
                            <div>{{ catalog.catalog_name }}</div>
                            <div
                              v-if="getParentPathText(catalog)"
                              class="catalog-parent-path-text dull-the-text comm-lengthy-value-styles"
                            >
                              {{ getParentPathText(catalog) }}
                            </div>
                            <div v-if="barcodeInfoFromStartup && 'enable_assets_tree_count' in barcodeInfoFromStartup && barcodeInfoFromStartup.enable_assets_tree_count" style="display: flex;">
                              <div v-if="'total_catalogs' in catalog && catalog.total_catalogs" style="padding-inline-end: 15px;">
                                <span style="color: #757575 !important;">{{$t('Catalogs')}}:</span> {{catalog.total_catalogs}}
                              </div>
                              <div v-if="'total_assets' in catalog && catalog.total_assets">
                                <span style="color: #757575 !important;">{{$t('Assets')}}:</span> {{catalog.total_assets}}
                              </div>
                            </div>
                            <div
                                v-if="isDockPanelOpen() && getDockMetadataItems(catalog).length"
                                :key="'dock_metadata_row_' + catalog._id + '_' + getDockMetadataRefreshKey(catalog)"
                                class="dock-metadata-kv-row catalog-dock-metadata-row"
                                style="margin: 6px 0 0 0px !important;"
                              >
                                <div
                                  v-for="item in getDockMetadataItems(catalog)"
                                  :key="'dock_metadata_' + catalog._id + '_' + item.key + '_' + getDockMetadataDisplayValue(item)"
                                  class="dock-metadata-kv-item"
                                  :class="{
                                    'dock-metadata-kv-item--multiline': isDockMetadataMultiline(item),
                                    'dock-metadata-kv-item--wide': isDockMetadataWide(item)
                                  }"
                                  :title="item.key + ': ' + getDockMetadataDisplayValue(item)"
                                >
                                  <span class="dock-metadata-key">{{ item.key }}:</span>

                                  <template v-if="isDockMetadataMultiline(item)">
                                    <span class="dock-metadata-value-wrapper">
                                      <span
                                        class="dock-metadata-value metadata-multiline-value"
                                        :class="{ expanded: isMultilineExpanded(catalog, item) }"
                                      >
                                        <template v-if="getMetadataHighlight(catalog, item)">
                                          <span v-html="getMetadataHighlight(catalog, item)"></span>
                                        </template>

                                        <template v-else>
                                          {{ getDockMetadataDisplayValue(item) }}
                                        </template>
                                      </span>

                                      <button
                                        v-if="shouldShowDockMetadataToggle(item)"
                                        type="button"
                                        class="metadata-show-more-btn"
                                        @click.stop="toggleMultilineExpand(catalog, item)"
                                      >
                                        {{ isMultilineExpanded(catalog, item) ? $t('see less') : $t('see more') }}
                                      </button>
                                    </span>
                                  </template>

                                  <template v-else>
                                    <span class="dock-metadata-value">
                                      <template v-if="getMetadataHighlight(catalog, item)">
                                        <span v-html="getMetadataHighlight(catalog, item)"></span>
                                      </template>

                                      <template v-else>
                                        {{ getDockMetadataDisplayValue(item) }}
                                      </template>
                                    </span>
                                  </template>
                                </div>
                              </div>
                          </td>
                          <td
                            v-if="
                              !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                            "
                            :title="getDateAndTimeInConfiguredFormat(catalog.created_datetime? catalog.created_datetime: catalog.asset_created_datetime)"
                          >
                            {{ getDateAndTimeInConfiguredFormat(catalog.created_datetime? catalog.created_datetime:catalog.asset_created_datetime, true) }}
                          </td>
                          <td
                            v-if="
                              !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                            "
                            :title="getDateAndTimeInConfiguredFormat(catalog.asset_added_datetime)"
                          >
                            {{ getDateAndTimeInConfiguredFormat(catalog.asset_added_datetime, true) }}
                          </td>
                          <td
                            style="text-align:end"
                            v-if="
                              !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                            "
                          >
                            -
                          </td>
                          <template v-if="!isDockPanelOpen()">
                            <td
                              v-for="column in enabledMetadataColumns"
                              :key="'metadata_value_' + catalog._id + '_' + column._id"
                              class="metadata-config-col metadata-value-cell"
                              :class="{ 'metadata-multiline-td': isMetadataMultiline(catalog, column) }"
                              @mousedown.stop>
                              <template v-if="isMetadataMultiline(catalog, column)">
                                <div
                                  class="metadata-multiline-value"
                                  :class="{ expanded: isMultilineExpanded(catalog, column) }"
                                  :title="getMetadataColumnValue(catalog, column)"
                                >
                                  <template v-if="getMetadataHighlight(catalog, column)">
                                    <span v-html="getMetadataHighlight(catalog, column)"></span>
                                  </template>
                          
                                  <template v-else>
                                    {{ getMetadataColumnValue(catalog, column) }}
                                  </template>
                                </div>
                          
                                <button
                                  v-if="shouldShowMultilineToggle(catalog, column)"
                                  type="button"
                                  class="metadata-show-more-btn"
                                  @click.stop="toggleMultilineExpand(catalog, column)"
                                >
                                  {{ isMultilineExpanded(catalog, column) ? $t('See less') : $t('See more') }}
                                </button>
                              </template>
                          
                              <template v-else>
                                <span :title="getMetadataColumnValue(catalog, column)">
                                  <template v-if="getMetadataHighlight(catalog, column)">
                                    <span v-html="getMetadataHighlight(catalog, column)"></span>
                                  </template>
                          
                                  <template v-else>
                                    {{ getMetadataColumnValue(catalog, column) }}
                                  </template>
                                </span>
                              </template>
                            </td>
                          </template>
                      </tr> 
                    </template>
                  </drag-select-container>
                  </template>
                </template>
                <template v-if="children && children.filter(op=>('catalog_type' in op && op.catalog_type == 'photo_album')).length">
                  <tr class="metadata-section-row">
                    <td colspan="999">
                  <div style="display: flex;justify-content: flex-start;align-items: flex-start;">
                    <div 
                      class="text-left"  style="padding: 10px 0px 0px 20px;color: rgb(119, 119, 119);margin: 11px;">
                      <svg  v-if="!showAlbumsInListView" v-on:click.stop.prevent="showAlbumsInListView = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                        <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                      </svg>
                      <svg v-if="showAlbumsInListView" v-on:click.stop.prevent="showAlbumsInListView = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                        <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                      {{$t('Photo Albums')}}
                    </div>
                  </div>
                    </td>
                  </tr>
                  <template v-if="showAlbumsInListView">
                    <drag-select-container name="drag-select-container" style="display:contents" attribute="attr" @change="dragSelect($event)">
                    <template  v-for="catalog in children.filter(op=>('catalog_type' in op && op.catalog_type == 'photo_album'))">
                      <tr :key="catalog._id"
                          :attr="catalog._id" 
                          @click.exact="selectElement($event,catalog)"
                          @dblclick="showCatalogDetails(catalog,'list-view')"
                          class="active-list-view"
                          :class="{ activeAsset: isFileSelected(catalog), 'reduce-opacity': catalog.asset_state == 'MARK FOR DELETE' }"
                          @click.ctrl="multiSelectElemet(catalog)"
                          @click.meta="multiSelectElemet(catalog)"
                          @contextmenu.stop.prevent="show($event, catalog)"
                          :ripple="false" 
                          data-app
                          >
                        <td>
            
                          <div style="position:relative;margin-inline-start: 5px;display: flex;align-items: center;justify-content: center;">
                            <div class="asset-thumbnail-hw-set" style="position:relative;">
                              <div class="thumbnail-hw-set"
                                @mouseleave="storyboardPreviewActiveId = null" :class="catalog.asset_state == 'MARK FOR DELETE'?'reduce-opacity':' '">
                                <img :src="getCatalogCoverPhoto(catalog)"  @error="(e) => replaceByDefaultImage(e,null)" alt="image" draggable="false"/>
                              </div>

                            <div v-if="eOMenu || !['GROWING'].includes(catalog.asset_state)" class="shortcut-actions-type-icons-wrapper" :class="eOMenu?'overWriteShortcutIconWrapper':''" style="z-index:2;">
                              <div class="overflow-parent-div">
                                <svg @click.stop.prevent="eOMenu=true;selectElement($event,catalog,false);show($event, selectedFileInfo)" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                  <title>{{$t('More actions')}}</title>
                                  <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <img
                            v-if="catalog.asset_state == 'GROWING'"
                            :src="growingFileGif"
                            alt="loading"
                            style="height:50px;width:65px;position:absolute;bottom:23%;inset-inline-start:19%;"
                          />
                          <svg v-else-if="catalog.asset_state == 'ERROR'" xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#af0000" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16" style="position:absolute;bottom:35%;inset-inline-start:39%">
                              <title>{{$t('ERROR')}}</title>
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                          </svg>
                          <img
                            v-else-if="catalog.asset_state == 'MARK FOR DELETE'"
                            :src="markForDeleteIcn"
                            alt="markfordelete"
                            style="height:20px;width:20px;position:absolute;bottom:26%;inset-inline-start:42%"
                          />
                          </div>
                        </td>
                        <td style="text-align:start;position:relative;padding:15px;vertical-align: top;">
                          <div>
                            <div class="slug-title-row" style="display:flex">
                                <div class="svg-icons-display list-media-type-icon"
                                style="position:relative;margin-top:1px !important">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#5f777d" class="bi bi-folder-fill" viewBox="0 0 16 16" style="width:20px !important;height:20px !important">
                                    <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                                  </svg>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-card-image photo-album-svg" viewBox="0 0 16 16">
                                    <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
                                    <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5z"/>
                                  </svg>
                                </div>
                                <div  v-if="catalog.highlight && catalog.highlight['catalog_name']" class="transcript-content-wrapper" style="display:flex;width: 100%; align-items: flex-start;">
                                    <div style="flex: 1;">
                                      <span v-for="(cContent,index) in catalog.highlight['catalog_name']" :key="'catalog_name'+index" v-html="getTranscriptHighlightContent(cContent)"  class="transcript-content-highlight" style="white-space: pre-wrap;"></span>
                                      <div v-if="barcodeInfoFromStartup && 'enable_assets_tree_count' in barcodeInfoFromStartup && barcodeInfoFromStartup.enable_assets_tree_count" style="display: flex;">
                                        <div v-if="'total_catalogs' in catalog && catalog.total_catalogs" style="padding-inline-end: 15px;">
                                          <span style="color: #757575 !important;">{{$t('Catalogs')}}:</span> {{catalog.total_catalogs}}
                                        </div>
                                        <div v-if="'total_assets' in catalog && catalog.total_assets">
                                          <span style="color: #757575 !important;">{{$t('Assets')}}:</span> {{catalog.total_assets}}
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div v-else>
                                  <span class="file-name-display-styles-in-list-view" :title="catalog.catalog_name" style="inset-inline-start:0px;position:relative !important">{{ catalog.catalog_name }}</span>  
                                  <div
                                    v-if="getParentPathText(catalog)"
                                    class="catalog-parent-path-text dull-the-text comm-lengthy-value-styles"
                                  >
                                    {{ getParentPathText(catalog) }}
                                  </div>
                                  <div v-if="barcodeInfoFromStartup && 'enable_assets_tree_count' in barcodeInfoFromStartup && barcodeInfoFromStartup.enable_assets_tree_count" style="display: flex;">
                                    <div v-if="'total_catalogs' in catalog && catalog.total_catalogs" style="padding-inline-end: 15px;">
                                      <span style="color: #757575 !important;">{{$t('Catalogs')}}:</span> {{catalog.total_catalogs}}
                                    </div>
                                    <div v-if="'total_assets' in catalog && catalog.total_assets">
                                      <span style="color: #757575 !important;">{{$t('Assets')}}:</span> {{catalog.total_assets}}
                                    </div>
                                  </div>
                                  <div
                                  v-if="isDockPanelOpen() && getDockMetadataItems(catalog).length"
                                  :key="'dock_metadata_row_' + catalog._id + '_' + getDockMetadataRefreshKey(catalog)"
                                  class="dock-metadata-kv-row catalog-dock-metadata-row"
                                  style="margin: 6px 0 0 0px !important;"
                                >
                                  <div
                                    v-for="item in getDockMetadataItems(catalog)"
                                    :key="'dock_metadata_' + catalog._id + '_' + item.key + '_' + getDockMetadataDisplayValue(item)"
                                    class="dock-metadata-kv-item"
                                    :class="{
                                      'dock-metadata-kv-item--multiline': isDockMetadataMultiline(item),
                                      'dock-metadata-kv-item--wide': isDockMetadataWide(item)
                                    }"
                                    :title="item.key + ': ' + getDockMetadataDisplayValue(item)"
                                  >
                                    <span class="dock-metadata-key">{{ item.key }}:</span>
                                
                                    <template v-if="isDockMetadataMultiline(item)">
                                      <span class="dock-metadata-value-wrapper">
                                        <span
                                          class="dock-metadata-value metadata-multiline-value"
                                          :class="{ expanded: isMultilineExpanded(catalog, item) }"
                                        >
                                          <template v-if="getMetadataHighlight(catalog, item)">
                                            <span v-html="getMetadataHighlight(catalog, item)"></span>
                                          </template>
                                
                                          <template v-else>
                                            {{ getDockMetadataDisplayValue(item) }}
                                          </template>
                                        </span>
                                
                                        <button
                                          v-if="shouldShowDockMetadataToggle(item)"
                                          type="button"
                                          class="metadata-show-more-btn"
                                          @click.stop="toggleMultilineExpand(catalog, item)"
                                        >
                                          {{ isMultilineExpanded(catalog, item) ? $t('see less') : $t('see more') }}
                                        </button>
                                      </span>
                                    </template>
                                
                                    <template v-else>
                                      <span class="dock-metadata-value">
                                        <template v-if="getMetadataHighlight(catalog, item)">
                                          <span v-html="getMetadataHighlight(catalog, item)"></span>
                                        </template>
                                
                                        <template v-else>
                                          {{ getDockMetadataDisplayValue(item) }}
                                        </template>
                                      </span>
                                    </template>
                                  </div>
                                </div>
                                </div>
                            </div>
                          </div>
                        </td>
                        <td v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible" :title="getDateAndTimeInConfiguredFormat(catalog.created_datetime? catalog.created_datetime:catalog.asset_created_datetime)" style="vertical-align: top;padding-top: 15px;">{{getDateAndTimeInConfiguredFormat(catalog.created_datetime? catalog.created_datetime:catalog.asset_created_datetime, true)}}</td>
                        <td v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible" :title="getDateAndTimeInConfiguredFormat(catalog.asset_added_datetime)" style="vertical-align: top;padding-top: 15px;">{{getDateAndTimeInConfiguredFormat(catalog.asset_added_datetime, true)}}</td>
                        <td v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible" style="text-align:end;vertical-align: top;padding-top: 15px;">-</td>
                        <template v-if="!isDockPanelOpen()">
                          <td
                            v-for="column in enabledMetadataColumns"
                            :key="'metadata_value_' + catalog._id + '_' + column._id"
                            class="metadata-config-col metadata-value-cell"
                            :class="{ 'metadata-multiline-td': isMetadataMultiline(catalog, column) }"
                          >
                            <template v-if="isMetadataMultiline(catalog, column)">
                              <div
                                class="metadata-multiline-value"
                                :class="{ expanded: isMultilineExpanded(catalog, column) }"
                                :title="getMetadataColumnValue(catalog, column)"
                              >
                                <template v-if="getMetadataHighlight(catalog, column)">
                                  <span v-html="getMetadataHighlight(catalog, column)"></span>
                                </template>
                        
                                <template v-else>
                                  {{ getMetadataColumnValue(catalog, column) }}
                                </template>
                              </div>
                        
                              <button
                                v-if="shouldShowMultilineToggle(catalog, column)"
                                type="button"
                                class="metadata-show-more-btn"
                                @click.stop="toggleMultilineExpand(catalog, column)"
                              >
                                {{ isMultilineExpanded(catalog, column) ? $t('See less') : $t('See more') }}
                              </button>
                            </template>
                        
                            <template v-else>
                              <span :title="getMetadataColumnValue(catalog, column)">
                                <template v-if="getMetadataHighlight(catalog, column)">
                                  <span v-html="getMetadataHighlight(catalog, column)"></span>
                                </template>
                        
                                <template v-else>
                                  {{ getMetadataColumnValue(catalog, column) }}
                                </template>
                              </span>
                            </template>
                          </td>
                        </template>
                      </tr>
                    </template>
                  </drag-select-container>
                  </template>
                </template>
                <template v-if="children.filter(op=>(('catalog_type' in op) && (['package'].includes(op.catalog_type)))).length">
                  <tr class="metadata-section-row">
                    <td colspan="999">
                  <div v-if="children.filter( op=>(('catalog_type' in op) && (['package'].includes(op.catalog_type)))).length"
                    class="text-left" style="padding: 10px 0px 0px 20px; color: #777;margin: 11px;">
                    <svg  v-if="!showPackagesInListView" v-on:click.stop.prevent="showPackagesInListView = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                      <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                    </svg>
                    <svg v-if="showPackagesInListView" v-on:click.stop.prevent="showPackagesInListView = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                      <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                    </svg>
                      {{$t('Packages')}}
                  </div>
                    </td>
                  </tr>
                  <template v-if="showPackagesInListView">

                  <drag-select-container name="drag-select-container" style="display:contents" attribute="attr" @change="dragSelect($event)">
                    <template  v-for="catalog in children.filter(op=>(('catalog_type' in op) && (['package'].includes(op.catalog_type))))">
                      <tr :key="catalog._id"
                          :attr="catalog._id" 
                          @click.exact="selectElement($event,catalog)"
                          @dblclick="showCatalogDetails(catalog,'list-view')"
                          class="active-list-view"
                          :class="{ activeAsset: isFileSelected(catalog), 'reduce-opacity': catalog.asset_state == 'MARK FOR DELETE' }"
                          @click.ctrl="multiSelectElemet(catalog)"
                          @click.meta="multiSelectElemet(catalog)"
                          @contextmenu.stop.prevent="show($event, catalog)"
                          :ripple="false" 
                          data-app
                          style="vertical-align: middle;"
                          >
                          <td>
                            <StoryBoardImagePreview :ref="'storyboard'+catalog._id" v-if="getFileMimeType(catalog) == 'video' && storyboardPreviewActiveId == catalog._id" :assetDetails="catalog"></StoryBoardImagePreview>
                            <div v-if="'catalog_cover_photo_path' in catalog && catalog.catalog_cover_photo_path.trim().length > 0"
                              style="display: flex;justify-content: center;height: 40px !important;">
                              <div class="card" style="width: 39px; height: 100%; overflow: hidden; display: flex; background-color: transparent;border-radius: 7px;"
                              :style="catalog.asset_state == 'MARK FOR DELETE'?'inset-inline-start:9px;':''">
                                <img class="card-img-top" :src="getCatalogCoverPhoto(catalog)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap" style="background-color: transparent;height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;">
                              </div>
                              <img v-if="catalog.asset_state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;inset-inline-end :15%;top:24px;">
                            </div>
                            <div v-else-if="'catalog_cover_photo_file_uid' in catalog && catalog.catalog_cover_photo_file_uid.trim().length > 0 && catalog.catalog_cover_photo_file_uid.startsWith('svg-')" style="height: 30px;width: 30px;margin: auto;" v-html="getSvgIconForCoverPhoto(catalog.catalog_cover_photo_file_uid.split('svg-')[1])"></div>
                            <div v-else>
                              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#858585" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                              </svg>
                              <img v-if="catalog.asset_state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;inset-inline-end :28%;">
                            </div></td>
                          <td class="comm-lengthy-value-styles slugname-list-cell" style="text-align:start" :title="catalog.dir_name">
                            <div>{{ catalog.catalog_name }}</div>
                            <div
                              v-if="getParentPathText(catalog)"
                              class="catalog-parent-path-text dull-the-text comm-lengthy-value-styles"
                            >
                              {{ getParentPathText(catalog) }}
                            </div>
                            <div v-if="barcodeInfoFromStartup && 'enable_assets_tree_count' in barcodeInfoFromStartup && barcodeInfoFromStartup.enable_assets_tree_count" style="display: flex;">
                              <div v-if="'total_catalogs' in catalog && catalog.total_catalogs" style="padding-inline-end: 15px;">
                                <span style="color: #757575 !important;">{{$t('Catalogs')}}:</span> {{catalog.total_catalogs}}
                              </div>
                              <div v-if="'total_assets' in catalog && catalog.total_assets">
                                <span style="color: #757575 !important;">{{$t('Assets')}}:</span> {{catalog.total_assets}}
                              </div>
                            </div>
                            <div
                            v-if="isDockPanelOpen() && getDockMetadataItems(catalog).length"
                            :key="'dock_metadata_row_' + catalog._id + '_' + getDockMetadataRefreshKey(catalog)"
                            class="dock-metadata-kv-row catalog-dock-metadata-row"
                            style="margin: 6px 0 0 0px !important;"
                          >
                            <div
                              v-for="item in getDockMetadataItems(catalog)"
                              :key="'dock_metadata_' + catalog._id + '_' + item.key + '_' + getDockMetadataDisplayValue(item)"
                              class="dock-metadata-kv-item"
                              :class="{
                                'dock-metadata-kv-item--multiline': isDockMetadataMultiline(item),
                                'dock-metadata-kv-item--wide': isDockMetadataWide(item)
                              }"
                              :title="item.key + ': ' + getDockMetadataDisplayValue(item)"
                            >
                              <span class="dock-metadata-key">{{ item.key }}:</span>
                          
                              <template v-if="isDockMetadataMultiline(item)">
                                <span class="dock-metadata-value-wrapper">
                                  <span
                                    class="dock-metadata-value metadata-multiline-value"
                                    :class="{ expanded: isMultilineExpanded(catalog, item) }"
                                  >
                                    <template v-if="getMetadataHighlight(catalog, item)">
                                      <span v-html="getMetadataHighlight(catalog, item)"></span>
                                    </template>
                          
                                    <template v-else>
                                      {{ getDockMetadataDisplayValue(item) }}
                                    </template>
                                  </span>
                          
                                  <button
                                    v-if="shouldShowDockMetadataToggle(item)"
                                    type="button"
                                    class="metadata-show-more-btn"
                                    @click.stop="toggleMultilineExpand(catalog, item)"
                                  >
                                    {{ isMultilineExpanded(catalog, item) ? $t('see less') : $t('see more') }}
                                  </button>
                                </span>
                              </template>
                          
                              <template v-else>
                                <span class="dock-metadata-value">
                                  <template v-if="getMetadataHighlight(catalog, item)">
                                    <span v-html="getMetadataHighlight(catalog, item)"></span>
                                  </template>
                          
                                  <template v-else>
                                    {{ getDockMetadataDisplayValue(item) }}
                                  </template>
                                </span>
                              </template>
                            </div>
                          </div>
                          </td>
                          <td
                            v-if="
                              !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                            "
                            :title="getDateAndTimeInConfiguredFormat(catalog.created_datetime? catalog.created_datetime:catalog.asset_created_datetime)"
                          >
                            {{ getDateAndTimeInConfiguredFormat(catalog.created_datetime? catalog.created_datetime:catalog.asset_created_datetime, true) }}
                          </td>
                          <td
                            v-if="
                              !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                            "
                            :title="getDateAndTimeInConfiguredFormat(catalog.asset_added_datetime)"
                          >
                            {{ getDateAndTimeInConfiguredFormat(catalog.asset_added_datetime, true) }}
                          </td>
                          <td
                            style="text-align:end"
                            v-if="
                              !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                            "
                          >
                            -
                          </td>
                          <template v-if="!isDockPanelOpen()">
                            <td
                              v-for="column in enabledMetadataColumns"
                              :key="'metadata_value_' + catalog._id + '_' + column._id"
                              class="metadata-config-col metadata-value-cell"
                              :class="{ 'metadata-multiline-td': isMetadataMultiline(catalog, column) }"
                            >
                              <template v-if="isMetadataMultiline(catalog, column)">
                                <div
                                  class="metadata-multiline-value"
                                  :class="{ expanded: isMultilineExpanded(catalog, column) }"
                                  :title="getMetadataColumnValue(catalog, column)"
                                >
                                  <template v-if="getMetadataHighlight(catalog, column)">
                                    <span v-html="getMetadataHighlight(catalog, column)"></span>
                                  </template>
                          
                                  <template v-else>
                                    {{ getMetadataColumnValue(catalog, column) }}
                                  </template>
                                </div>
                          
                                <button
                                  v-if="shouldShowMultilineToggle(catalog, column)"
                                  type="button"
                                  class="metadata-show-more-btn"
                                  @click.stop="toggleMultilineExpand(catalog, column)"
                                >
                                  {{ isMultilineExpanded(catalog, column) ? $t('See less') : $t('See more') }}
                                </button>
                              </template>
                          
                              <template v-else>
                                <span :title="getMetadataColumnValue(catalog, column)">
                                  <template v-if="getMetadataHighlight(catalog, column)">
                                    <span v-html="getMetadataHighlight(catalog, column)"></span>
                                  </template>
                          
                                  <template v-else>
                                    {{ getMetadataColumnValue(catalog, column) }}
                                  </template>
                                </span>
                              </template>
                            </td>
                          </template>
                      </tr> 
                    </template>
                  </drag-select-container>
                  </template>
                </template>
                <template v-if="assetsList && assetsList.length">
                  <tr class="metadata-section-row">
                    <td colspan="999">
                  <div style="display: flex;justify-content: flex-start;align-items: flex-start;margin: 10px;">
                    <input v-on:change.stop="selectAllFiles" v-model='allFilesSelected' type="checkbox" class="text-light ml-4 bigger-checkboxes" style="margin-inline-start: -5px !important;">
                    <div 
                      class="text-left"  style="padding: 2px 0px 0px 10px; color: #777">
                      <svg  v-if="!showFilesInListView" v-on:click.stop.prevent="showFilesInListView = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                        <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                      </svg>
                      <svg v-if="showFilesInListView" v-on:click.stop.prevent="showFilesInListView = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                        <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                      {{$t('Files')}}
                      <!-- {{"Files ( " + totalAssetsDisplay(totalAssets) + " )"}} -->
                    </div>
                    <!-- <div style="padding: 10px 20px 0px 0px;display: flex;align-items: center;">
                      <label for="select_all_files_checkbox"  class="mb-0">Select all</label></div> -->
                  </div>
                    </td>
                  </tr>
                  <template v-if="showFilesInListView">

                  <drag-select-container name="drag-select-container"  :settings="{ draggability: false }" style="display:contents" attribute="attr" @change="dragSelect($event)">
                    <template v-for="file in assetsList">
                      <tr :key="file._id" @click.exact="selectElement($event,file)"
                          @dblclick="showAssetDetails(file,'list-view')"
                          class="active-list-view"
                          :class="{ activeAsset: isFileSelected(file) }"
                          @click.ctrl="multiSelectElemet(file)"
                          @click.meta="multiSelectElemet(file)"
                          @contextmenu.stop.prevent="show($event, file)" :ripple="false" data-app  :attr="file._id"
                          > 
                          <!-- <td>
                            <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" v-model="selected" :value="file._id"/>
                          </td> -->
                        <td class="asset-preview-col">
            
                          <div style="position:relative;margin-inline-start: 5px;display: flex;align-items: center;justify-content: center;">
                            <div class="asset-thumbnail-hw-set" ref="thumbnailwrapper" :data-thumbnailwrapperid="file._id" style="position:relative;">
                              <div class="thumbnail-hw-set"  @mousemove="handleMouseMoveForStoryBoardPreview($event,file)"
                                @mouseleave="storyboardPreviewActiveId = null" :class="file.asset_state == 'MARK FOR DELETE' || file.state == 'ERROR'?'reduce-opacity':' '">
                                <StoryBoardImagePreview :ref="'storyboard'+file._id" v-if="getFileMimeType(file) == 'video' && storyboardPreviewActiveId == file._id" :assetDetails="file"></StoryBoardImagePreview>
                                <img :src="getThumbnailPath(file,'FOR_SVG_THUMBNAIL')"  @error="(e) => replaceByDefaultImage(e,file,'FOR_SVG_THUMBNAIL')" alt="image" draggable="false"/>
                                <div v-if="'mime_type' in file && file.mime_type && (file.mime_type.startsWith('video') || file.mime_type.startsWith('audio')) && 'duration' in file && file.duration"
                                    class="comm-thumbnail-view-duration-label">
                                    {{getHumanReadableDuration(file.duration)}}
                                  </div>
                              </div>
                              <div v-if='checkIfDisabled(file)' :id="'assetResolution_'+file._id" class="thumbnail-view-resolution-label">
                                  {{ getReadableResolutionValue(file) }}
                              </div>
                            <div v-if="eOMenu || !['GROWING'].includes(file.state)" class="shortcut-actions-type-icons-wrapper" :class="eOMenu?'overWriteShortcutIconWrapper':''" style="z-index:2;">
                              <template v-if="!['MARK FOR DELETE'].includes(file.state)  &&
                                                  !['no-access','browse'].includes(file.permissions) &&
                                                  (Object.keys(selectedFileInfo).length >= 1 || Object.keys(selectedFiles).length == 1 ||
                                                      Object.keys(selectedFileInfo).length <= 0 && Object.keys(selectedFiles).length <= 0 ||
                                                        !isFileSelected(file))">
                                <svg v-if="!lockRestrictedAction('Download', file) && isFileActionEnabled('Download',file.permissions) && !['GROWING','MARK FOR DELETE'].includes(file.state)" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-download" viewBox="0 0 16 16">
                                  <title>{{$t('Download')}}</title>
                                  <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                  <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                </svg>
                                <svg v-if="!lockRestrictedAction('Chat', file) && file.asset_type == 'subclip' && isFileActionEnabled('Chat',file.permissions)" @click="shareInChatSubclips(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-dots-fill" viewBox="0 0 16 16">
                                  <title>{{$t('Share in chat')}}</title>
                                  <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                </svg>
                                <svg v-if="!lockRestrictedAction('Share', file) && file.asset_type != 'subclip' && isFileActionEnabled('Share',file.permissions) && !['GROWING','MARK FOR DELETE'].includes(file.state)" @click="handleShareAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-share-fill" viewBox="0 0 16 16">
                                  <title>{{$t('Share')}}</title>
                                  <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                                </svg>
                                <svg v-if="!lockRestrictedAction('tag-metadata',file) && isFileActionEnabled('tag-metadata',file.permissions) && !['GROWING','MARK FOR DELETE'].includes(file.state)" @click="handleTagMetadataAssetHoverAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-tag-fill" viewBox="0 0 16 16">
                                  <title>{{$t('Tag Metadata')}}</title>
                                  <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                                </svg>
                              </template>
                              <svg v-if="!lockRestrictedAction('Preview', file)" @click="showAssetDetails(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#928f8f">
                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                <title>{{$t('Preview')}}</title>
                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                              </svg>
                              <div class="overflow-parent-div">
                                <svg @click.stop.prevent="eOMenu=true;selectElement($event,file,false);show($event, selectedFileInfo)" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                  <title>{{$t('More actions')}}</title>
                                  <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                </svg>
                                <!-- <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                      <div class="dropdown-item p-2 copy-link-action" @click="setClipBoardText(file)" title="Copy link">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fdfff4" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                            <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                            <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                        </svg>
                                        Copy link</div>
                                        <div v-if="isEnabled('Chat')" class="dropdown-item p-2 copy-link-action" @click="openShareInChat()" title="">
                                          <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-share-fill" viewBox="0 0 16 16">
                                            <title></title>
                                            <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                                          </svg>
                                          Share in chat</div>
                                </div> -->
                              </div>
                            </div>
                              <div class="storage-type-icons-wrapper" v-if="(file.storage_class != undefined && file.storage_class.length) || file.asset_type == 'subclip' || file.subclips_present == true || (Object.keys(file).includes('asset_ttl') && file.asset_ttl) || (file.location_info && (Object.keys(file.location_info).includes('alto')|| Object.keys(file.location_info).includes('gravity_deep')) || 'lock' in file)" style="bottom: -2px" :style="file.asset_type == 'subclip'?'min-width:40px;':''">
                                <template v-if="file.asset_state != 'MARK FOR DELETE' && Object.keys(file).includes('asset_ttl') && file.asset_ttl">
                                  <div v-if="loadTTLIcons(file.asset_ttl)" v-html="loadTTLIcons(file.asset_ttl)" style="width: 22px;"></div>
                                </template>
                                <svg v-if="file.subclips_present == true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                  <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                  <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                  <title>{{$t('Have Subclips')}}</title>
                                </svg>
                                <svg v-if="'asset_lock' in file && file.asset_lock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18" height="18" style="position: relative;top: -1px;">
                                  <path fill="#cdcdcd" d="M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z" style=""></path>
                                  <path fill="#e98405" d="M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z" style=""></path>
                                  <path fill="#55524e" d="M24 28A3 3 0 1 0 24 34A3 3 0 1 0 24 28Z" style=""></path>
                                  <title>{{$t('Locked')}}</title>
                                </svg>
                                <div v-if="file.asset_type == 'subclip'" style="position:relative;inset-inline-start:4px;width:30px">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16">
                                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                    <title>{{$t('Subclip')}}</title>
                                  </svg>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;top:1px">
                                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                    <title>{{$t('Subclip')}}</title>
                                  </svg>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Glacier')}}</title>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Deep Archive')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Glacier Deep Archive')}}</title>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Instant Retrieval')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Glacier Instant Retrieval')}}</title>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Standard')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Standard')}}</title>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" v-if="Object.keys(file).includes('archived') && file.archived" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16">
                                  <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                                  <title>{{$t('Archived')}}</title>
                                </svg>
                                <template v-if="'location_info' in file && 'gravity_deep' in file.location_info">
                                  <div v-for="cId of file.location_info.gravity_deep.container_ids" :key="cId">
                                    <svg v-if="cId == 'CACHE'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-c-square" viewBox="0 0 16 16">
                                      <title>{{ cId }}</title>
                                      <path d="M8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"/>
                                      <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"/>
                                    </svg>
                                    <svg v-else-if="cId.startsWith('Tape')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cassette-fill" viewBox="0 0 16 16">
                                      <title>{{ cId }}</title>
                                      <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h.191l1.862-3.724A.5.5 0 0 1 4 10h8a.5.5 0 0 1 .447.276L14.31 14h.191a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z"/>
                                      <path d="m13.191 14-1.5-3H4.309l-1.5 3h10.382Z"/>
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hdd-fill" viewBox="0 0 16 16">
                                      <title>{{ cId }}</title>
                                      <path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>
                                    </svg>
                                  </div>
                                </template>
                                <img v-if="file.location_info && Object.keys(file.location_info).includes('alto')" title="ALTO" :src="altoLogo" alt="alto"/>
                              </div>
                          </div>
                          <img
                            v-if="file.state == 'GROWING'  || file.asset_state == 'GROWING'"
                            :src="growingFileGif"
                            alt="loading"
                            style="height:50px;width:65px;position:absolute;bottom:23%;inset-inline-start:19%;user-select: text !important;cursor:text;"
                          />
                          <svg v-else-if="file.state == 'ERROR'" xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#af0000" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16" style="position:absolute;bottom:35%;inset-inline-start:39%">
                              <title>{{$t('ERROR')}}</title>
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                          </svg>
                          <img
                            v-else-if="file.asset_state == 'MARK FOR DELETE'"
                            :src="markForDeleteIcn"
                            alt="markfordelete"
                            style="height:20px;width:20px;position:absolute;bottom:26%;inset-inline-start:42%"
                          />
                          </div></td>
                          <td class="comm-lengthy-value-styles slugname-list-cell" style="text-align:start" :title="file.dir_name" > <!-- @mousedown.stop -->
                          <div>
                            <div>
                              <div class="slug-title-row">
                                <span
                                  v-html="getSvgIconsOfMediaTypes(file)"
                                  class="svg-icons-display list-media-type-icon"
                                ></span>
                              
                                <span
                                  class="file-name-display-styles-in-list-view"
                                  :title="getFileName(file)"
                                  v-if="!getHighlightFilename(file,getFileName(file)).highlight"
                                >
                                  {{ getFileName(file) }}
                                  <span
                                    class="file-extension"
                                    v-if="barcodeInfoFromStartup.enable_file_extension && file.mime_type"
                                    :title="file.mime_type.split('/')[1]"
                                  >
                                    .{{file.mime_type.split('/')[1]}}
                                  </span>
                                </span>
                              
                                <span
                                  class="file-name-display-styles-in-list-view"
                                  :title="getFileName(file)"
                                  v-else
                                >
                                  <span
                                    class="dynamic-slug-name"
                                    v-html="getHighlightFilename(file,getFileName(file)).slugname"
                                  ></span>
                                  <span
                                    class="file-extension"
                                    v-if="barcodeInfoFromStartup.enable_file_extension && file.mime_type"
                                    :title="file.mime_type.split('/')[1]"
                                  >
                                    .{{file.mime_type.split('/')[1]}}
                                  </span>
                                </span>
                              </div>
                                <template v-if="file.highlight && file.highlight['metadata.description']">
                                    <span v-for="desc in file.highlight['metadata.description']" :key="desc" v-html="desc"  class="secondary-dull-the-text description-alignment"></span>
                                </template>
                                <span v-else-if="!descriptionVisibilityArr.includes(file._id) && file.metadata && file.metadata.description && file.metadata.description.length > 200" class="secondary-dull-the-text description-alignment">&nbsp;-&nbsp;{{file.metadata.description.substring(0,200)}}...<span @click.stop.prevent="seeMoreDescription(file._id)"><b style="color:#bdbdbd">{{$t('see more')}}</b></span></span>
                                <span v-else-if="!descriptionVisibilityArr.includes(file._id) && file.metadata && file.metadata.description" class="secondary-dull-the-text description-alignment">&nbsp;-&nbsp;{{file.metadata.description}}</span>
                                <span v-else-if="descriptionVisibilityArr.includes(file._id) && file.metadata && file.metadata.description" class="secondary-dull-the-text description-alignment">&nbsp;-&nbsp;{{file.metadata.description}}<span @click.stop.prevent="seeLessDescription(file._id)"><b style="color:#bdbdbd">{{$t('see less')}}</b></span></span>
                                <div class="multi-transcript-content-wrapper" v-if="'transcript_highlight_data' in file && file['transcript_highlight_data'].length > 0">
                                  <div v-for="matchedInfo in file.transcript_highlight_data" :key="matchedInfo['uid']" class="transcript-list"> 
                                    <span style="flex-basis: 3%;display: flex;" >
                                      <svg v-if="transcriptSearchEntry && transcriptSearchEntry.uid == matchedInfo.uid && transcriptSearchEntry['state']=='playing'" @click.exact="pauseTranscriptPlay(matchedInfo)" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#9c9c9c" class="bi bi-pause-fill" viewBox="0 0 16 16">
                                        <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5"></path>
                                        <title>{{$t('Transcript')}}</title>
                                      </svg>
                                      <svg v-else @click.exact="playTranscriptFromSearchResults(matchedInfo)" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#9c9c9c" viewBox="0 0 16 16" class="bi bi-play-fill">
                                        <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
                                        <title>{{$t('Transcript')}}</title>
                                      </svg>
                                  </span>
                                  <div class="common-media-in-out-display">
                                    <span>{{getDurationFormatAsHHorMMSS(matchedInfo.media_in)}}</span> - <span>{{getDurationFormatAsHHorMMSS(matchedInfo.media_out)}}</span>
                                  </div>
                                    <div style="flex: 1;margin-inline-start:6px;" :key="matchedInfo['uid']">
                                      <span v-for="(transcriptContent,index) in matchedInfo['files.ai_info.transcript.content']" :key="'files.ai_info.transcript.content'+index" v-html="getTranscriptHighlightContent(transcriptContent)"  class="secondary-dull-the-text transcript-content-highlight"></span>
                                    </div>
                                  </div>
                                </div>
                                <div class="transcript-content-wrapper" style="display:flex;width: 100%; align-items: flex-start;margin-top: 11px;" v-else-if="file.highlight && file.highlight['files.ai_info.transcript.content']">
                                  <span style="flex-basis: 3%;display: flex;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-cc-square-fill" viewBox="0 0 16 16">
                                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.408 5.89c-.83 0-1.318.64-1.318 1.753v.742c0 1.108.479 1.727 1.318 1.727.69 0 1.138-.435 1.187-1.05h1.147v.114c-.058 1.147-1.029 1.938-2.343 1.938-1.612 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.319 0 2.29.812 2.343 1.999v.11H6.595c-.049-.638-.506-1.108-1.187-1.108Zm5.404 0c-.831 0-1.319.64-1.319 1.753v.742c0 1.108.48 1.727 1.319 1.727.69 0 1.138-.435 1.186-1.05h1.147v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.318 0 2.29.812 2.342 1.999v.11h-1.147c-.048-.638-.505-1.108-1.186-1.108Z"></path>
                                          <title>{{$t('Transcript')}}</title>
                                      </svg>
                                  </span>
                                    <div style="flex: 1;">
                                      <span v-for="(transcriptContent,index) in file.highlight['files.ai_info.transcript.content']" :key="'files.ai_info.transcript.content'+index" v-html="getTranscriptHighlightContent(transcriptContent)"  class="secondary-dull-the-text transcript-content-highlight"></span>
                                    </div>
                                </div>
                                <div  v-if="file.highlight && file.highlight['files.ai_info.ocr.script']" class="transcript-content-wrapper" style="display:flex;width: 100%; align-items: flex-start;margin-top: 11px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#eee">
                                    <path d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M17 4h3c1.1 0 2 .9 2 2v2h-2V6h-3V4zM4 8V6h3V4H4c-1.1 0-2 .9-2 2v2h2zm16 8v2h-3v2h3c1.1 0 2-.9 2-2v-2h-2zM7 18H4v-2H2v2c0 1.1.9 2 2 2h3v-2zM18 8H6v8h12V8z">
                                    </path>
                                    <title>{{$t('OCR')}}</title>
                                </svg>
                                    <div style="flex: 1;">
                                      <span v-for="(ocrContent,index) in file.highlight['files.ai_info.ocr.script']" :key="'files.ai_info.ocr.script'+index" v-html="getTranscriptHighlightContent(ocrContent)"  class="secondary-dull-the-text transcript-content-highlight"></span>
                                    </div>
                                </div>
                            </div>
                            <div
                              v-if="getParentPathText(file)"
                              class="dull-the-text comm-lengthy-value-styles"
                            >
                              {{ getParentPathText(file) }}
                            </div>
                            <div v-if="barcodeInfoFromStartup.enable_reference_id_workflow && file.reference_id" class="d-flex dull-the-text" style="position: relative;inset-inline-start:0px;display:flex;font-size:12px;flex-wrap:wrap;bottom: 4px;">
                              {{barcodeInfoFromStartup.alias &&  barcodeInfoFromStartup.alias.alias_name?barcodeInfoFromStartup.alias.alias_name:"Reference ID"}}:
                              <span style="color:#aaa"> &nbsp; {{file.reference_id}}</span></div>
                            <div v-if="file.ttl" class="d-flex dull-the-text" style="position: relative;inset-inline-start:0px;display:flex;font-size:12px;flex-wrap:wrap;bottom: 4px;">
                              <template v-if="calculateLeftOverTTLDays(file.ttl) >= 0">{{$t('Expires on')}}:</template>
                              <template v-else>{{$t('Expired on')}}:</template>
                              <span style="color:#aaa"> &nbsp; {{file.ttl.split('T')[0]}} ({{calculateLeftOverTTLDays(file.ttl)}} 
                                <template v-if="[-1,1].includes(calculateLeftOverTTLDays(file.ttl))">{{$t('day')}})</template>
                                <template v-else>{{$t('days')}})</template>
                              </span>
                            </div>
                            <div class="slugname-tags-block">
                              <template v-if="file.label_info && file.label_info.length">
                                <span class="display-label mr-1 mb-1" v-for="label in file.label_info" :key="label.label_id" :style="label.label_type == 'user_defined'?applyBorder(label):applyBackground(label)">
                                  <template v-if="label.name">{{label.name}}</template>
                                  <template v-else>{{$t('None')}}</template>
                                </span>
                              </template>
                            <span class="change-the-text-color mr-1 mb-1" v-if="Object.keys(file).includes('archived') && file.archived">Archived</span>
                              <template v-if="file.location_info && Object.keys(file.location_info).includes('alto')">
                                <span v-for="archivePath in file.location_info.alto.container_archive_path" class="change-the-text-color mr-1" :key="archivePath.container_id" style="white-space: pre-wrap;margin-bottom:2px;color: #46c5f5;border-color: #46b5f5;">{{archivePath.container_name}}</span>
                              </template>
                            <span class="change-the-text-color ml-1 mr-1 1 mb-1" v-if="file.storage_class != undefined && (file.storage_class.includes('Amazon S3 Glacier Instant Retrieval') || file.storage_class.includes('Amazon S3 Glacier') || file.storage_class.includes('Amazon S3 Standard') || file.storage_class.includes('Amazon S3 Glacier Deep Archive') )" style="color: #FFE15D;border: 1px solid #FFE15D;"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-fill" style="margin-bottom: 1px;" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                </svg> {{file.storage_class.includes('Amazon S3 Glacier Instant Retrieval')?"Amazon S3 Glacier Instant Retrieval":file.storage_class.includes('Amazon S3 Glacier')?"Amazon S3 Glacier":file.storage_class.includes('Amazon S3 Glacier Deep Archive')?"Amazon S3 Glacier Deep Archive":"Amazon S3 Standard"}}</span>
                              <div v-if="file.highlight && file.highlight['metadata.tag_values']" class="d-flex" style="flex-wrap:wrap">
                                <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;" v-for="tag in file.highlight['metadata.tag_values']" :key="tag">
                                  <div style="display: flex;align-items: center;width: 12px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-tag-fill" viewBox="0 0 16 16">
                                      <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                                    </svg>
                                  </div>
                                  <div v-html="tag"></div>
                                </div>
                              </div>
                              <div v-else-if="file.tag_info" class="d-flex" style="flex-wrap:wrap">
                                <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;" v-for="tag in file.tag_info" :key="tag">
                                  <div style="display: flex;align-items: center;width: 12px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-tag-fill" viewBox="0 0 16 16">
                                      <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                                    </svg>
                                  </div>
                                  <div>{{tag.name}}</div>
                                </div>
                              </div>

                              

                              <div v-if="file.highlight && file.highlight['files.ai_info.face_values']" class="d-flex" style="flex-wrap:wrap;">
                                <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.highlight['files.ai_info.face_values']" :key="detectedIndividual">
                                  <div style="display: flex;align-items: center;width: 12px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                                        <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"></path>
                                        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"></path>
                                        <title>{{$t('Profile')}}</title>
                                    </svg>
                                  </div>
                                  <div v-html="detectedIndividual"></div>
                                </div>
                              </div>
                              <div v-else-if="file.highlight && file.highlight['files.ai_info.face_detection.name']" class="d-flex" style="flex-wrap:wrap;">
                                <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.highlight['files.ai_info.face_detection.name']" :key="detectedIndividual">
                                  <div style="display: flex;align-items: center;width: 12px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                                        <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"></path>
                                        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"></path>
                                        <title>{{$t('Profile')}}</title>
                                    </svg>
                                  </div>
                                  <div v-html="detectedIndividual"></div>
                                </div>
                              </div>

                              <div v-else-if="file && file.ai_info && file.ai_info.face_detection" class="d-flex" style="flex-wrap:wrap">
                                <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.ai_info.face_detection" :key="detectedIndividual.uuid" v-show="detectedIndividual.name">
                                  <div style="display: flex;align-items: center;width: 12px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3a0a0" class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                                        <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"></path>
                                        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"></path>
                                        <title>{{$t('Profile')}}</title>
                                    </svg>
                                  </div>
                                  <div >{{detectedIndividual.name}}</div>
                                </div>
                              </div>
                              <div v-if="file.highlight && file.highlight['files.ai_info.obd_values']" class="d-flex" style="flex-wrap:wrap;">
                                <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.highlight['files.ai_info.obd_values']" :key="detectedIndividual">
                                  <div style="display: flex;align-items: center;width: 12px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-columns-gap" viewBox="0 0 16 16">
                                        <path d="M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z"></path>
                                        <title>{{$t('Object')}}</title>
                                    </svg>
                                  </div>
                                  <div v-html="detectedIndividual"></div>
                                </div>
                              </div>
                              <div v-else-if="file.highlight && file.highlight['files.ai_info.obd.name']" class="d-flex" style="flex-wrap:wrap;">
                                <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.highlight['files.ai_info.obd.name']" :key="detectedIndividual">
                                  <div style="display: flex;align-items: center;width: 12px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-columns-gap" viewBox="0 0 16 16">
                                        <path d="M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z"></path>
                                        <title>{{$t('Object')}}</title>
                                    </svg>
                                  </div>
              ￼                   <div v-html="detectedIndividual"></div>
                                </div>
                              </div>
                              <div v-else-if="file && file.ai_info && file.ai_info.obd" class="d-flex" style="flex-wrap:wrap">
                                <div class="change-the-text-color mr-1 ml-1 1 mb-1" style="color:#eee;border-color:#363636;background:#282d31;margin-bottom:6px;display: flex; gap: 3px;align" v-for="detectedIndividual in file.ai_info.obd" :key="detectedIndividual.uuid" v-show="detectedIndividual.name">
                                  <div style="display: flex;align-items: center;width: 12px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-columns-gap" viewBox="0 0 16 16">
                                        <path d="M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z"></path>
                                        <title>{{$t('Object')}}</title>
                                    </svg>
                                  </div>
                                  <div >{{detectedIndividual.name}}</div>
                                </div>
                              </div>

                            </div>
                          </div>
                          <div v-if="file.user_id" class="username-wrapper">
                            <div style="display: flex;justify-content: flex-start;text-align: start;width:100%;align-items:flex-start">
                              <span class="dull-the-text">{{$t('User name')}}:</span>
                              <div class="username-in-wrapper" >{{getDisplayDataOfUserUsingId(file.user_id).username }}</div>
                          </div>  
                          </div>
                          <div
                          v-if="isDockPanelOpen() && getDockMetadataItems(file).length"
                          :key="'dock_metadata_row_' + file._id + '_' + getDockMetadataRefreshKey(file)"
                          class="dock-metadata-kv-row"
                        >
                          <div
                            v-for="item in getDockMetadataItems(file)"
                            :key="'dock_metadata_' + file._id + '_' + item.key + '_' + getDockMetadataDisplayValue(item)"
                            class="dock-metadata-kv-item"
                            :class="{
                              'dock-metadata-kv-item--multiline': isDockMetadataMultiline(item),
                              'dock-metadata-kv-item--wide': isDockMetadataWide(item)
                            }"
                            :title="item.key + ': ' + getDockMetadataDisplayValue(item)"
                          >
                            <span class="dock-metadata-key">{{ item.key }}:</span>
                        
                            <template v-if="isDockMetadataMultiline(item)">
                              <span class="dock-metadata-value-wrapper">
                                <span
                                  class="dock-metadata-value metadata-multiline-value"
                                  :class="{ expanded: isMultilineExpanded(file, item) }"
                                >
                                  <template v-if="getMetadataHighlight(file, item)">
                                    <span v-html="getMetadataHighlight(file, item)"></span>
                                  </template>
                        
                                  <template v-else>
                                    {{ getDockMetadataDisplayValue(item) }}
                                  </template>
                                </span>
                        
                                <button
                                  v-if="shouldShowDockMetadataToggle(item)"
                                  type="button"
                                  class="metadata-show-more-btn"
                                  @click.stop="toggleMultilineExpand(file, item)"
                                >
                                  {{ isMultilineExpanded(file, item) ? $t('see less') : $t('see more') }}
                                </button>
                              </span>
                            </template>
                        
                            <template v-else>
                              <span class="dock-metadata-value">
                                <template v-if="getMetadataHighlight(file, item)">
                                  <span v-html="getMetadataHighlight(file, item)"></span>
                                </template>
                        
                                <template v-else>
                                  {{ getDockMetadataDisplayValue(item) }}
                                </template>
                              </span>
                            </template>
                          </div>
                        </div>
                            </td>
                        <td  class="date-created-col" v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible" :title="getDateAndTimeInConfiguredFormat(file.created_datetime? file.created_datetime:file.asset_created_datetime)" style="vertical-align: top;padding-top: 15px;">{{getDateAndTimeInConfiguredFormat(file.created_datetime? file.created_datetime:file.asset_created_datetime, true)}}</td>
                        <td  class="date-added-col" v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible" :title="getDateAndTimeInConfiguredFormat(file.asset_added_datetime)" style="vertical-align: top;padding-top: 15px;">{{getDateAndTimeInConfiguredFormat(file.asset_added_datetime, true)}}</td>
                        <td class="size-col" v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible" style="text-align:end;vertical-align: top;padding-top: 15px;">{{humaniseSize(file)}}</td>
                        <template v-if="!isDockPanelOpen()">
                          <td
                            v-for="column in enabledMetadataColumns"
                            :key="'metadata_value_' + file._id + '_' + column._id"
                            class="metadata-config-col metadata-value-cell"
                            :class="{ 'metadata-multiline-td': isMetadataMultiline(file, column) }"
                          >
                          <template v-if="isMetadataMultiline(file, column)">
                            <div
                              class="metadata-multiline-value"
                              :class="{ expanded: isMultilineExpanded(file, column) }"
                              :title="getMetadataColumnValue(file, column)"
                            >
                              <template v-if="getMetadataHighlight(file, column)">
                                <span v-html="getMetadataHighlight(file, column)"></span>
                              </template>

                              <template v-else>
                                {{ getMetadataColumnValue(file, column) }}
                              </template>
                            </div>
                        
                            <button
                              v-if="shouldShowMultilineToggle(file, column)"
                              type="button"
                              class="metadata-show-more-btn"
                              @click.stop="toggleMultilineExpand(file, column)"
                            >
                              {{ isMultilineExpanded(file, column) ? $t('See less') : $t('See more') }}
                            </button>
                          </template>
                        
                          <template v-else>
                            <span :title="getMetadataColumnValue(file, column)">
                              <template v-if="getMetadataHighlight(file, column)">
                                <span v-html="getMetadataHighlight(file, column)"></span>
                              </template>

                              <template v-else>
                                {{ getMetadataColumnValue(file, column) }}
                              </template>
                            </span>
                          </template>
                        </td>
                        </template>
                        <!-- <td style="text-align:center" v-if="!getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible">{{file.asset_type}}</td> -->
                      </tr>
                    </template>
                  </drag-select-container>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
    class="catalog-footer-safe"
    :class="{ 'dock-open-footer': isDockPanelOpen && isDockPanelOpen(),
    'both-panels-open-footer': getIsMetadataDockVisible && getIsAssetsDetailsPanelVisible}"
  >
    <div class="catalog-footer-selected-safe">
      <div
        v-for="(value, opkey) of getSelectedAssetsCount()"
        :key="opkey"
        class="catalog-footer-selected-item"
      >
        <div class="catalog-footer-selected-label">{{ opkey }} :</div>
        <div class="catalog-footer-selected-value" :title="value">{{ value }}</div>
      </div>
    </div>
  
    <div
      class="catalog-footer-pagination-safe"
      :class="{ 'single-page-pagination': shouldShowPaginationControls && !shouldShowPaginationControls() }"
    >
    <div v-if="totalAssets > -1" class="catalog-pagination-count">
      <template v-if="totalAssets <= assetsPerpage">
        {{ totalAssets }} {{ totalAssets === 1 ? $t('record') : $t('records') }}
      </template>
    
      <template v-else>
        {{$t('Showing')}}
        {{ ((page - 1) * assetsPerpage) + 1 }}
        {{$t('to')}}
        {{ Math.min(page * assetsPerpage, totalAssets) }}
        {{$t('of')}}
        {{ totalAssets }}
        {{$t('records')}}
      </template>
    </div>
  
      <div class="catalog-pagination-controls-row">
        <pagination
          v-if="totalAssets > -1"
          v-model="page"
          :records="totalAssets"
          :per-page="assetsPerpage"
          @paginate="paginate"
          :options="options"
        />
  
        <div v-if="totalAssets > -1" class="nav-item dropdown show customise-pagination-option">
          <a
            class="nav-item nav-link dropdown-toggle"
            id="bd-versions"
            data-toggle="dropdown"
            data-display="static"
            aria-haspopup="true"
            aria-expanded="true"
            style="padding:5px"
          >
            <svg width="20" height="20" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
              <title>{{$t('Custom Pagination')}}</title>
              <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
            </svg>
          </a>
  
          <div
            class="dropdown-menu dropdown-menu-md-right p-0"
            aria-labelledby="bd-versions"
            style="position:absolute;bottom:30px;inset-inline-end:6px;"
          >
            <a class="dropdown-item p-2 d-flex" @click="openCustomPaginationModal = true">
              <span>{{$t('Custom Pagination')}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
      
      <v-menu
        v-model="showMoreSubMenu"
        :position-x="submenuX"
        :position-y="submenuY"
        :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
        absolute
        offset-y
        >
        <v-list :class="eOMenu?'vmenuOnHover':''">
          <v-list-item
            v-for="item in contextMenuMoreOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles), {boundComponent: getComponent})
            "
            >
            <v-list-item-title class="d-inline-flex">
              <div style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>
          <!-- <v-list-item
              v-if="Object.keys(selectedFileInfo).length != 0 && selectedFileInfo.asset_type != 'subclip' && selectedFileInfo.asset_state == 'READY' && selectedFileInfo.asset_type != 'catalog' && isEnabled('Hype-SocialMedia') && (selectedFileInfo.mime_type.startsWith('video') ||selectedFileInfo.mime_type.startsWith('image'))"
              @click="editAndShareAction()"
          >
            <v-list-item-title class="d-inline-flex">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hand-thumbs-up-fill" viewBox="0 0 16 16">
                  <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a9.84 9.84 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733.058.119.103.242.138.363.077.27.113.567.113.856 0 .289-.036.586-.113.856-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.163 3.163 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.82 4.82 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"/>
                </svg>
              </div>
              <div style="padding-inline-start:7px;">Hype share</div>
            </v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-menu>
      <v-menu
        v-model="showMoreSubMenu"
        :position-x="submenuX"
        :position-y="submenuY"
        :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
        absolute
        offset-y
        >
        <v-list :class="eOMenu?'vmenuOnHover':''">
          <v-list-item
            v-for="item in contextMenuMoreOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles) , {boundComponent: getComponent})
            "
            >
            <v-list-item-title class="d-inline-flex">
              <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>

          <!-- ------removed hardcodede Hype Share option -->
          <!-- <v-list-item
              v-if="Object.keys(selectedFileInfo).length != 0 && selectedFileInfo.asset_type != 'subclip' && selectedFileInfo.asset_state == 'READY' && selectedFileInfo.asset_type != 'catalog' && isEnabled('Hype-SocialMedia') && (selectedFileInfo.mime_type.startsWith('video') ||selectedFileInfo.mime_type.startsWith('image'))"
              @click="editAndShareAction()"
          >
            <v-list-item-title class="d-inline-flex">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hand-thumbs-up-fill" viewBox="0 0 16 16">
                  <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a9.84 9.84 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733.058.119.103.242.138.363.077.27.113.567.113.856 0 .289-.036.586-.113.856-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.163 3.163 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.82 4.82 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"/>
                </svg>
              </div>
              <div style="padding-inline-start:7px;">Hype share</div>
            </v-list-item-title>
          </v-list-item> -->
          
        </v-list>
      </v-menu>
            <v-menu 
        v-model="showArchiveToSubMenu"
        :position-x="submenuX"
        :position-y="submenuY"
        :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
        absolute
        offset-y
        >
        <v-list>
          <v-list-item
            v-for="item in contextMenuArchiveOptions"
            :key="item.pool_id"
            @click="archiveto(item.pool_id)"
            >
            <v-list-item-title class="d-inline-flex">
              <div v-html="getTargetBinIcon"></div>
              <div style="padding-inline-start:7px;">{{ getPoolLabel(item) }}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu 
        v-model="showOpenWithToolSubmenu"
        :position-x="submenuX"
        :position-y="submenuY"
        :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
        absolute
        offset-y
        >
        <v-list :class="eOMenu?'vmenuOnHover':''">
            <v-list-item
              v-for="item in contextMenuOpenWithOptions"
              :key="item._id"
              @click=" getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo) , {boundComponent: getComponent})"
              >
            <v-list-item-title v-if="'action_name' in item" class="d-inline-flex">
              <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
            </v-list-item>
          </v-list>
      </v-menu>
      <v-menu 
        v-model="showRetrieveFromSubmenu"
        :position-x="submenuX"
        :position-y="submenuY"
        :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
        absolute
        offset-y
        >
        <v-list>
          <v-list-item
            v-for="item in contextMenuRetrieveOptions"
            :key="item.pool_id"
            @click="retrieveFrom(item.pool_id)"
            >
            <v-list-item-title class="d-inline-flex">
              <div v-html="getTargetBinIcon"></div>
              <div style="padding-inline-start:7px;">{{ getPoolLabel(item) }}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu 
          v-model="showExportSubMenu"
          :position-x="submenuX"
          :position-y="submenuY"
          :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
          absolute
          offset-y
          >
          <v-list :class="eOMenu?'vmenuOnHover':''">
            <v-list-item
              v-for="item in contextMenuExportOptions"
              :key="item._id"
              @click="getExportEventHandler(item, $event)"
              >
            <v-list-item-title v-if="'action_name' in item" class="d-inline-flex">
              <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
              <v-list-item-title v-else class="d-inline-flex">
                <div v-html="getTargetBinIcon"></div>
                <div style="padding-inline-start:7px;">to {{ item.bin_id }}</div>
              </v-list-item-title>
            </v-list-item>
          </v-list>
      </v-menu>
      <v-menu 
          v-model="showExportProxySubMenu"
          :position-x="submenuX"
          :position-y="submenuY"
          :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
          absolute
          offset-y
          >
          <v-list :class="eOMenu?'vmenuOnHover':''">
            <v-list-item
              v-for="(item,index) in contextMenuExportProxyOptions"
              :key="item._id+index"
              @click="getExportProxyEventHandler(item, $event)"
              >
            <v-list-item-title v-if="'action_name' in item" class="d-inline-flex">
              <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
              <v-list-item-title v-else class="d-inline-flex">
                <div v-html="getTargetBinIcon"></div>
                <div style="padding-inline-start:7px;">to {{ item.bin_id }}</div>
              </v-list-item-title>
            </v-list-item>
          </v-list>
      </v-menu>
      <v-menu 
          v-model="showShareSubmenu"
          :position-x="submenuX"
          :position-y="submenuY"
          :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
          absolute
          offset-y
          >
          <v-list :class="eOMenu?'vmenuOnHover':''">
            <v-list-item
            v-for="item in contextMenuShareOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles) , {boundComponent: getComponent})
            "
            >
            <v-list-item-title class="d-inline-flex">
              <div v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>
          </v-list>
      </v-menu>
      <v-menu 
          v-model="showCatalogsIconSubmenu"
          :position-x="submenuX"
          :position-y="submenuY"
          :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
          absolute
          offset-y
          >
          <v-list :class="eOMenu?'vmenuOnHover':''">
            <v-list-item
            v-for="item in contextMenuCatalogIconOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles), {boundComponent: getComponent})
            "
            >
            <v-list-item-title class="d-inline-flex" :style="(item.label == 'From your Computer')?('position: relative;justify-content: flex-start;width: 100%;'):''">
              <div style="position: relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
            <input type="file" v-if="item.label == 'From your Computer'" 
                id="img-input"
                ref="uploadFile"
                @change="uploadCPFromSystemUpload($event)"
                accept="image/*"
                style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%;">
          </v-list-item>
          </v-list>
      </v-menu>
      <v-menu 
          v-model="showAIToolsSubmenu"
          :position-x="submenuX"
          :position-y="submenuY"
          :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
          absolute
          offset-y
          >
          <v-list :class="eOMenu?'vmenuOnHover':''">
            <v-list-item
            v-for="item in contextMenuAIToolOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles) , {boundComponent: getComponent})
            "
            >
            <v-list-item-title class="d-inline-flex">
              <div v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>
          </v-list>
      </v-menu>
      <v-menu
        v-model="showNewSubMenu"
        :position-x="submenuNewX"
        :position-y="submenuNewY"
        :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
        absolute
        offset-y
        >
        <v-list :class="eOMenu?'vmenuOnHover':''">
          <v-list-item
            v-for="item in contextMenuNewOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo) , {boundComponent: getComponent})
            "
          >
            <v-list-item-title class="d-inline-flex">
              <div style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-model="showImportSubMenu"
        :position-x="submenuNewX"
        :position-y="submenuNewY"
        :content-class="viewType === false ? 'catalog-list-sub-context-menu' : ''"
        absolute
        offset-y
        >
        <v-list :class="eOMenu?'vmenuOnHover':''">
          <v-list-item
            v-for="item in contextMenuImportOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo) , {boundComponent: getComponent})
            "
          >
            <v-list-item-title class="d-inline-flex">
              <div style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        :content-class="viewType === false ? 'catalog-list-main-context-menu' : ''"
        absolute
        offset-y
        >
        <v-list :class="eOMenu?'vmenuOnHover':''">
          <v-list-item
          v-for="item in contextMenuOptions" :key="item._id" 
          @mouseenter="showSubmenu(item, $event)"
          @click='getEventHandler(item,"onClick",item.onEvents)($event,Object.assign({},selectedFiles), {boundComponent: getComponent})'
          >
            <v-list-item-title class="d-inline-flex"
              >
              <div style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start: 7px">
                {{$t(item.label)}}
              </div>
              <svg v-if="item.sub_menu != undefined && item.sub_menu != 'DEFAULT'" xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-chevron-right comm-icon-rtl" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;fill: #c5c5c5;">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
              </svg>
              </v-list-item-title
            >
          </v-list-item>
          <v-list-item
              v-if="(workspace && workspace == 'Projects' && (Object.keys(selectedFileInfo).length != 0)) || (Object.keys(selectedFileInfo).length != 0 && selectedFileInfo.asset_type == 'subclip')" @mouseenter="preventSubMenuDisplay()"
              @click="openAssetInCatalog(selectedFileInfo)">
            <v-list-item-title class="d-inline-flex">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-folder-fill" viewBox="0 0 16 16">
                    <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                </svg>
              </div>
              <div style="padding-inline-start:7px;">{{workspace && workspace == 'Projects'?$t('Open in catalogs workspace'):$t('Open Parent Asset')}}</div>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
              v-if="Object.keys(selectedFileInfo).length != 0 && Object.keys(selectedFileInfo).includes('asset_type')" @mouseenter="preventSubMenuDisplay()"
              @click="openProperties()"
          >
            <v-list-item-title class="d-inline-flex">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
              </svg>
              </div>
              <div style="padding-inline-start:7px;">{{$t('Properties')}}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
  </template>
    </div>
</template>


<script>
import MetadataView from "./MetadataView.vue";
import catalogWorkspaceMixin from "../../mixins/CatalogWorkspaceMixin.js";
import Utils from "../../components.utils.js";

export default {
  mixins:[catalogWorkspaceMixin],
  props: ["refreshFileInfoAndShowAsset", "catalogSelected","viewType","thumbnailSize","thumbnailAspectRatio","thumbnailScale","rootPathPermission","isAdvancedSearchEnabled", "getCookieValueOfJobPanel", "workspace", "rootCatalogInfo","isMetadataView","basicAssetInfo","isNLPSearchMode"],
  components: {
    MetadataView
  },
  data() {
    return {
      defaultTopNavHeight: 0,
      currentTopNavHeight: 0,
      topNavResizeObserver: null,
    };
  },

  computed: {
    thumbnailCardStyle() {
      const legacySizes = { small: 160, medium: 220, large: 300 };
      const value = legacySizes[this.thumbnailSize] || Number(this.thumbnailSize);
      const width = Number.isFinite(value) && value >= 160 && value <= 300 ? value : 220;
      const ratio = { landscape: 9 / 16, square: 1, portrait: 16 / 9 }[this.thumbnailAspectRatio] || 9 / 16;
      return { '--asset-width': width + 'px', '--asset-height': Math.round(width * ratio) + 'px', '--thumbnail-ratio': { landscape: '16 / 9', square: '1 / 1', portrait: '9 / 16' }[this.thumbnailAspectRatio] || '16 / 9' };
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.observeTopNavHeightForTable();
    });
  },

  beforeDestroy() {
    if (this.topNavResizeObserver) {
      this.topNavResizeObserver.disconnect();
      this.topNavResizeObserver = null;
    }
  },
  watch: {
    isMetadataView(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          this.observeTopNavHeightForTable();
        });
      }
    },

    viewType() {
      this.$nextTick(() => {
        this.observeTopNavHeightForTable();
      });
    }
  },
  methods: {
    scrollToTheSelectedFile() {
      let fileInfo = {};

      if (Object.keys(this.selectedFileInfo).length) {
        fileInfo = this.selectedFileInfo;
      } else if (Object.keys(this.selectedFiles).length) {
        fileInfo = Object.values(this.selectedFiles)[0];
      }

      const shouldScroll =
        !this.lastClosedDialogMap.isAssetUnselectRequired &&
        Object.keys(fileInfo).length > 0;

      if (shouldScroll) {
        const isThumbnailView = this.viewType;
        const selector = isThumbnailView
          ? `li[attr="${fileInfo._id}"]`
          : `tr[attr="${fileInfo._id}"]`;
        const wrapperSelector = isThumbnailView
          ? '.assets-view-wrapper'
          : '.list-view-wrapper';

        setTimeout(() => {
          const element = this.$el.querySelector(selector);
          const container = this.$el.querySelector(wrapperSelector);

          if (!element || !container) return;

          if (!isThumbnailView) {
            Utils.scrollToElement(element, container);
            return;
          }

          const elementRect = element.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const visibleTop = containerRect.top + container.clientTop;
          const visibleBottom = visibleTop + container.clientHeight;

          if (elementRect.top < visibleTop) {
            container.scroll({
              top: container.scrollTop + elementRect.top - visibleTop,
              behavior: 'smooth'
            });
          } else if (elementRect.bottom > visibleBottom) {
            container.scroll({
              top: container.scrollTop + elementRect.bottom - visibleBottom,
              behavior: 'smooth'
            });
          }
        }, 0);
      }

      this.lastClosedDialogMap.isAssetUnselectRequired = true;
      return true;
    },
    updateFallbackThumbnailStyle(event, file) {
      const image = event.target;
      const wrapper = image.closest('.asset-thumbnail');
      if (!wrapper) return;
      const src = image.currentSrc || image.src || '';
      const svgImage = /^data:image\/svg\+xml/i.test(src) || /\.svg(?:[?#]|$)/i.test(src);
      const isSvgAsset = (file.mime_type || '').toLowerCase().split(';')[0] === 'image/svg+xml';
      wrapper.classList.toggle('fallback-svg-thumbnail', svgImage && !isSvgAsset);
    },
    observeTopNavHeightForTable() {
      if (this.topNavResizeObserver) {
        this.topNavResizeObserver.disconnect();
        this.topNavResizeObserver = null;
      }

      const topNavRef = this.$refs.top_nav_bar;
      const topNavEl = topNavRef && (topNavRef.$el || topNavRef);

      if (!topNavEl || typeof ResizeObserver === "undefined") {
        return;
      }

      const initialHeight = Math.ceil(topNavEl.getBoundingClientRect().height || 0);
      this.defaultTopNavHeight = initialHeight;
      this.currentTopNavHeight = initialHeight;

      this.topNavResizeObserver = new ResizeObserver(entries => {
        const entry = entries && entries[0];

        if (!entry) {
          return;
        }

        this.currentTopNavHeight = Math.ceil(entry.contentRect.height || 0);
      });

      this.topNavResizeObserver.observe(topNavEl);
    },
    getAdjustedTableHeightStyle() {
      const isDepartmentEnabled =
        this.barcodeInfoFromStartup &&
        this.barcodeInfoFromStartup.enable_department;

      const topNavHeight =
        this.currentTopNavHeight ||
        this.defaultTopNavHeight ||
        (
          this.$refs.top_nav_bar &&
          this.$refs.top_nav_bar.$el
            ? Math.ceil(this.$refs.top_nav_bar.$el.getBoundingClientRect().height || 0)
            : 0
        );

      const fallbackOffset = isDepartmentEnabled ? 150 : 100;
      const footerAndSpacingHeight = isDepartmentEnabled ? 100 : 50;

      const totalOffset = topNavHeight
        ? topNavHeight + footerAndSpacingHeight
        : fallbackOffset;

      const heightValue = `calc(100% - ${totalOffset}px)`;

      return {
        height: heightValue,
        maxHeight: heightValue,
        "--catalog-assets-height": heightValue
      };
    }
  }
};
</script>

<style lang="scss" scoped>
/* File cards retain the existing click handlers and thumbnail overlays. */
.thumbnail-view-ul.common-view-ul { --asset-width: 220px; --asset-height: 124px; --thumbnail-ratio: 16 / 9; }
.thumbnail-view-ul.common-view-ul li { box-sizing: border-box; width: var(--asset-width); height: auto; min-height: calc(var(--asset-height) + 40px); margin: 12px 16px 4px 0; padding: 0; border: 1px solid rgba(205, 218, 229, .13); border-radius: 10px; background: #262731; overflow: visible; }
.thumbnail-view-ul.common-view-ul li .asset-thumbnail { width: 100%; height: auto; min-height: 0; aspect-ratio: var(--thumbnail-ratio); overflow: hidden; margin: 0; border-radius: 9px 9px 0 0; background: #1a1e21; }
.thumbnail-view-ul.common-view-ul li .thumbnail-view { width: 100%; height: 100%; overflow: hidden; border-radius: 9px 9px 0 0; }
.thumbnail-view-ul.common-view-ul li .thumbnail-view img { width: 100%; height: 100%; max-width: none; max-height: none; object-fit: contain; border-radius: 0; }
.thumbnail-view-ul.common-view-ul.thumbnail-fill li .thumbnail-view img { object-fit: cover; }
/* Keep SVG fallback artwork smaller while allowing real thumbnails to fill the tile. */
.thumbnail-view-ul.common-view-ul li .asset-thumbnail.fallback-svg-thumbnail .thumbnail-view img,
.thumbnail-view-ul.common-view-ul.thumbnail-fill li .asset-thumbnail.fallback-svg-thumbnail .thumbnail-view img,
.thumbnail-view-ul.common-view-ul li .asset-thumbnail.svg-as-thumbnail .thumbnail-view img,
.thumbnail-view-ul.common-view-ul.thumbnail-fill li .asset-thumbnail.svg-as-thumbnail .thumbnail-view img {
  width: 48px; height: 48px; max-width: 45%; max-height: 45%; object-fit: contain;
}
.thumbnail-view-ul.common-view-ul li .thumbnail-data { box-sizing: border-box; min-height: 40px; padding: 8px; text-align: start !important; align-items: center; overflow: hidden; }
.thumbnail-view-ul.common-view-ul li .thumbnail-data { gap: 6px; }
.thumbnail-view-ul.common-view-ul li .thumbnail-data .svg-icons-display { flex: 0 0 18px; width: 18px; height: 18px; inset-inline-end: 0; display: flex; align-items: center; justify-content: center; }
.thumbnail-view-ul.common-view-ul li .thumbnail-data .file-name { flex: 1 1 auto; min-width: 0; width: auto; max-width: 100% !important; align-items: center; inset-inline-start: 0; top: 2; }
.thumbnail-view-ul.common-view-ul li .thumbnail-data .dynamic-slug-name { min-width: 0; margin-top: 0; }
.thumbnail-view-ul.common-view-ul li .thumbnail-data .file-extension-thumbnail-view { margin-top: 0; }
.thumbnail-view-ul.common-view-ul li .asset-thumbnail .storage-type-icons-wrapper { inset-inline-end: 0; bottom: 0; }
.thumbnail-view-ul.common-view-ul li:hover { border-color: rgba(205, 218, 229, .28); }
.thumbnail-view-ul.common-view-ul li.activeCatalog .thumbnail-data { width: 100%; inset-inline-start: 0; }






  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $secondary-border-color: 1px solid #2b2b2b;
  $row-border-color: #212121;
  $secondary-border-color:#767676;


@mixin storage-image-styles {
    height: 18px !important;
    width: 16px !important;
    border-radius: 5px !important;
    object-fit: contain;
    margin: 3px;
}


.keyword-highlight-wrapper{
    text-align: start;
    margin-inline-start: 6px;
    margin-top: -24px;
    color: $dull-text-color;
    font-size: 11px;
}

.activeAsset,
.activeMultipleAssets {
  border: 1px solid $row-border-color !important;
  background: $bg-color-on-hover;
  border-radius: 5px !important;
  td:first-child,
  th:first-child {
    border-radius: 10px 0 0 10px;
  }

  // Set border-radius on the top-right and bottom-right of the last table data on the table row
  td:last-child,
  th:last-child {
    border-radius: 0 10px 10px 0;
  }
  .thumbnail-data {
    float: inline-start;
    background: #1879e28c !important;
    position: relative;
    width: 102%;
    inset-inline-start: -4px;
    .svg-icons-display{
      inset-inline-end:0px;
      bottom:-1px;
    }
  }
}


// .thumbnail-view-ul{
//   li:hover{
//     border: $border-color;
//     border-radius: 5px;
//   }
// }
.thumbnail-view-ul {
  list-style-type: none;
  display: inline-flex;
  flex-wrap: wrap;
  padding: 0px;
  margin-top: 0px;
  width: 100%;
  padding-inline-start: 20px;
  justify-content: start;
  overflow: auto;
  li {
   display: inline-block;
    margin-inline-end: 10px;
    width: 174px;
    padding-inline-start: 5px;
    margin-top: 5px;
    height: 128px;
    .asset-thumbnail {
      height: 92px;
      width: 162px;
      border-radius: 7px;
      margin-top: 8px;
      //border:$border-color;
      position:relative;
      img {
        max-width: 100%;
        max-height: 100%;
        border-radius: 7px;
        object-fit: contain;
        border-radius: 7px;
      }
    }
    .thumbnail-data {
      text-align: center !important;
    }
  }
}

.activeAsset.active-list-view{
  color:$active-blue !important;
  .description-alignment{
    color:$active-blue !important;
  }
}

.active-list-view{
  .shortcut-actions-type-icons-wrapper{
    inset-inline-end:-8px !important;
    top:0px;
  }
}

    .activeAsset.active-list-view .overWriteShortcutIconWrapper{
      visibility: visible !important;
    }
.folder-view-ul {
  padding-top: 10px;
  margin-bottom: 10px;
  .folder-view-li {
    display: inline-flex !important;
    height: 52px !important;
    border: 1px solid #3a3a3a;
    border-radius: 6px;
    .folder-view {
      font-size: 30px;
    }
    .catalogs-data {
      margin-top: 15px;
      margin-inline-start: 7px;
      width: 118px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: start;
    }
  }
}

.folder-view-li:hover{
  border: 1px solid $secondary-border-color !important;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.folder-view-ul {
  padding-top: 10px;
  margin-bottom: 10px;
  .folder-view-li {
    display: inline-flex !important;
    height: 52px !important;
    border: $border-color;
    border-radius: 6px;
    .folder-view {
      font-size: 30px;
    }
    .folder-data {
      margin-top: 15px;
      margin-inline-start: 7px;
      width: 118px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: start;
    }
  }
}
.reduce-opacity{
  opacity: 0.5
}

.customise-pagination-option{
    width: 32px;
    display: inline-flex;
    justify-content: start;
    align-items: center;

}

::v-deep {
  .view-tags {
    font-size: 12px !important;
    min-height: 26px !important;
    display: inline-flex !important;
    margin: 2px !important;
    border: $border-color !important;
    border-radius: 15px !important;
    min-width: 50px !important;
    padding: 4px !important;
    text-align: center;
    width: auto !important;
    justify-content: center;
    span {
      padding: 0px 8px !important;
      margin-inline-start: 0px !important;
      font-size: 12px !important;
      border-radius: 15px !important;
      position: relative !important;
      top: 1px !important;
    }
  }
  font[color~=OrangeRed] {
      color: $highlight-font-color !important;
  }
  .page-item.disabled .page-link {
    background-color: $secondary-background-color;
    border: $border-color;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color;
    // border: none;
    border: $border-color;
    color: $active-blue;
    z-index: 0;
  }
  .page-link {
    background-color: $secondary-background-color;
    border: $border-color;
    // border: none;
    color: $text-color;
    padding: 5px;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
.pagination {
  float: inline-end;
  margin-bottom: 0px !important;
  margin-inline-end: 8px;
}
.VuePagination__count {
  color: $secondary-text-color !important;
  margin-bottom: 0px !important;
  font-size: 12px;
  margin-inline-end: 7px;
  margin-top: 1px;
  float: inline-end;
  margin-inline-start: 5px;
  position: relative;
  top:5px;
}
.VuePagination__pagination-item {
    font-size: 14px;
    min-width: 27px;
}
.VuePagination__pagination-item-prev-chunk {
  display:none;
}
.VuePagination__pagination-item-next-chunk{
  display:none;
}

.VuePagination__pagination-item-prev-page{
  width:50px;
}

.VuePagination__pagination-item-next-page{
  width:50px;
}

.VuePagination__pagination-item-next-page a:before{
  width:50px;
  content: "next ";
}

.VuePagination__pagination-item-prev-page a:after{
  width:50px;
  content: " prev";
}
.v-list{
  padding:0px !important;
}
.v-list-item{
  text-align: start;
  border: $border-color !important;
  min-height: 37px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
    .v-list-item__title{
          font-size: 14px !important;
          color:$text-color !important;
    }
  }
.v-menu__content{
  width:225px !important;
  z-index: 9999 !important;
  overflow:auto;
  max-height:85vh;
}
}


.icon-background-on-hover:hover{
  background: #d1d2d31a;
}

.icon-background-on-hover{
  padding: 6px;
  height: 28px;
  width: 28px;
  border-radius: 4px;
}

.activeCatalog, .activeCatalog:hover {
  border: 2px solid $active-blue !important;
  border-radius: 5px !important;
  .thumbnail-data {
    background: #1879e28c !important;
    position: relative;
    width: 102%;
    inset-inline-start: -4px;
    .svg-icons-display {
      inset-inline-end: 0px;
      bottom: -1px;
    }
  }
  .folder-view {
    svg {
      color: $active-blue !important;
    }
  }
}

::v-deep {
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }

.theme--dark.v-list{
  background: $secondary-background-color !important;
}

.vmenuOnHover .v-list-item:hover .v-list-item__title{
              color:#fdfff4!important;
}
.vmenuOnHover{
      padding:0px !important;
      font-size: 14px!important;
      border: 1px solid #757575;
      background: #15181b !important;
    .v-list-item{
      text-align: start;
      min-height: 37px !important;
      padding: 0 10px !important;
      font-size: 12px !important;
      border: 1px solid #2b2b2b !important;
        .v-list-item__title{
              font-size: 14px !important;
              color:#eee !important;
        }
      }
    .v-menu__content{
      width:225px !important;
      z-index: 9999 !important;
    }
  }
}


.table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  margin: 0px 15px;
  thead {
    color: $dull-text-color !important;
    position: relative;
    width: 100%;
    th {
      position: sticky;
      top: 0;
      background: $primary-background;
      z-index: 9;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr {
      min-height: 60px;
      height: auto;
    }
  }
}

.table-cell-styles{
  th{
    border-top:none !important;
  }
  td{
    border-top:none !important;
    padding:10px;
  }
}

.table-with-border {
  thead {
    border-bottom: $border-color;
  }
  tr {
    border-bottom: $border-color;
  }
}


input[type="checkbox"]:after {
  line-height: 1.5em;
  content: "";
  display: inline-block;
  width: 22px;
  height: 21px;
  margin-top: -1px;
  margin-inline-start: -1px;
  border: $border-color;
  border-radius: 0.25em;
  background: $primary-background;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}
.asset-thumbnail-hw-set{
  // height:68px;
  height:78px;
  width:130px;
  border-radius: 7px;
  // margin-bottom:10px;
  //border: $border-color;
  .thumbnail-hw-set{
    height:100%;
    position: relative;
    align-items: center;
    display: inline-flex;
    justify-content:center;
    width:100%;
    img{
      // height:100%;
      // width:100%;
      // border-radius: 7px;
      // object-fit:cover;

      max-width: 100%;
      max-height: 100%;
      border-radius: 7px;
      object-fit: contain;
      border-radius: 7px;
    }
  }
}

.assets-view-wrapper {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
  width: 100%;
}

.list-view-wrapper{
  height: 100% !important;
  width: 100%;
  min-height: 0;
}

.thumbnail-data{
 svg{
      border-radius: 5px;
      height:100%;
      width:100%;
    }
}
.svg-icons-display{
    height: 20px;
    width: 20px;
    position: relative;
    opacity:0.8;
    inset-inline-end: 5px;
}

.file-name{
    white-space: nowrap;
      width: 81%;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: initial;
      position: relative;
      inset-inline-start:2px;
      top: 2px;
}

.storage-type-icons-wrapper,.storage-type-icons-wrapper-list-view{
  position: absolute;
  svg.img{
    margin:3px;
  }
}

.storage-type-icons-wrapper-list-view{
  color: $dull-text-color;
  inset-inline-end: 0px;
  img{
      @include storage-image-styles;
  }
  svg{
      margin:3px;
    }
}

.storage-type-icons-wrapper{
    color: #999;
    background: #1a1a1ab3;
    min-width: 30px;
    width: auto;
    inset-inline-end: -2px;
    bottom: -2px;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    display:flex;
    justify-content: center;
    img{
      @include storage-image-styles;
    }
    svg{
      margin:3px;
    }
}
.shortcut-actions-type-icons-wrapper{
        visibility: hidden;
        color: #999;
        background: #000000c9;
        min-width: 30px;
        width: auto;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        position: absolute;
        top: 6px;
        inset-inline-end: 6px;
        line-height: 1;
        margin-inline-start: 8px;
        border: unset;
        --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
        box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
        display: flex;
        padding: 2px;
        border-radius: 0.375em;
        svg{
            margin-inline-start: 6px;
            margin-inline-end: 6px;
        }
    }
    .asset-thumbnail:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
           
        }
    }
    .overflow-parent-div {
      .overflow-menu{
        background: #1e1e1e;
        font-size: 14px !important;
        border: 1px solid #757575;
        top: 19px;
        display: inline-block;
        inset-inline-start: calc(100% - 25px);
        padding-top: 3px !important;
        // visibility: hidden;
      }
    }
   
    .asset-thumbnail-hw-set:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
        }
    }
    .shortcut-actions-type-icons-wrapper svg:hover{
        fill: #fdfff4;
    }
    .shortcut-actions-type-icons-wrapper .copy-link-action:hover{
        color: #fdfff4 !important;
    }
    .shortcut-actions-type-icons-wrapper .copy-link-action{
        color: #a3adad !important;
    }
    .activeCatalog .overWriteShortcutIconWrapper{
      visibility: visible !important;
    }
    .hover-context-menu-action{
      align-items: center;
      font-size: 14px !important;
      .svg-hover-context-menu-icon{
        float: inline-start;
        width: 20px;
        height: 20px;
      }
    }
.file-name-display-styles-in-list-view{
   white-space: nowrap;
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: initial;
    position: absolute;
}

.comm-lengthy-value-styles{
   white-space: normal;
    // max-width: 80%;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // text-align: initial;
    // position: relative;
    // inset-inline-start :-2px;
    // top: 2px;
    word-break: break-all;
}

    .dropdown-menu{
      background-color:$secondary-background-color !important;
      border: $border-color;
      .dropdown-item{
      color:$text-color;
      font-size:14px !important; 
      }
  }

  .dropdown-item:hover{
      background-color:$bg-color-on-hover !important;
  }
  .nav-item{
      color: $secondary-text-color !important;
  }

  .dropdown-toggle:after{
    display:none !important;
  }

  .dull-the-text{
    color: $secondary-text-color;
  }
  // .dull-the-text:hover{
  //   color: #1d9bd1;
  //   text-decoration: underline;;
  // }

  .secondary-dull-the-text{
    color: $secondary-text-color;
    white-space: pre-wrap;
  }
  .description-alignment{
    position:relative;
    top:2px;
  }
  .change-the-text-color{
    color: $dull-text-color;
    text-transform: uppercase;
    height: 22px;
    width: fit-content;
    border: 1px solid #F49D1A;
    border-radius: 10px;
    padding: 3px 9px;
    color: #F49D1A;
    font-size: 10px;
    letter-spacing: 0.5px;
  }

  .thumbnail-view-resolution-label{
    color: #eee;
    position: absolute;
    top: 0px;
    inset-inline-start:0px;
    font-size: 10px;
    padding: 1px 5px;
    justify-content: center;
    display: flex;
    border-radius: 7px;
    align-items: center;
    margin: 2px;
  }

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
.bigger-checkboxes:focus{
  box-shadow: unset;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.res-FHD{
  // background: rgba(248, 120, 0, 0.6) !important;
  background: #f87800 !important;
  border: 1px solid #4a4a4a;
}
.res-fourK{
  background: #f8090199 !important;
  border: 1px solid #4a4a4a;
  //background: rgba(248, 9, 1, 0.6) !important;
}
.res-HD{
  // background: rgba(245, 241, 4, 0.6) !important;
  background: #f5f10499 !important;
  border: 1px solid #4a4a4a;
  color: #292a2b !important;
}
.res-SD{
  // background: rgba(29, 134, 140, 0.952) !important;
  background: #1d868cf3 !important;
  border: 1px solid #4a4a4a;
}
.photo-album-svg{
  height: 12px !important;
  width: 17px !important;
  inset-inline-end: 2px;
  position: absolute;  
  border-radius: 10px;
  background: transparent;
  top:6px;
  fill: #1a1e21;
}
.display-label{
  height: 22px;
  width: fit-content;
  border: 1px solid #F49D1A;
  border-radius: 10px;
  padding: 3px 9px;
  color: #F49D1A;
  font-size: 10px;
  letter-spacing: 0.5px;
}
.asset-thumbnail-hw-set.svg-as-thumbnail,.asset-thumbnail.svg-as-thumbnail{
   border: unset !important;
   background-image: linear-gradient(60deg, #29323c 0%, #485563 100%);
}

.file-extension{
  margin-inline-start: 5px;
  color: #aba7a7 !important;
  margin-top:2px
}
.file-extension-thumbnail-view{
  min-width: 51px;
  margin-inline-start: 5px;
  color: #aba7a7 !important;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dynamic-slug-name{
  margin-top:2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.multi-transcript-content-wrapper{
  display: flex;
  width: 100%;
  align-items: flex-start;
  margin-top: 11px;
  position: relative;
  flex-wrap: wrap;
  .transcript-list{
    display:inline-flex;
    width: 100%;
    margin-bottom:4px;
    svg{
      margin-inline-end: 2px;
    }
    svg:hover{
      fill:#eee;
    }
  }
}
.common-media-in-out-display{
  font-size: 14px;
  background: rgb(52, 52, 52);
  padding: 4px 5px; 
  justify-content: start; 
  display: flex; 
  border-radius: 3px;
  color: rgb(238, 238, 238) !important;
  gap:3px;
  height:28px;
}

.username-wrapper{
  display: flex;
  justify-content: flex-start;
  text-align: start;
  width: fit-content;
  align-items: center;
  border-radius: 5px;
  margin-top: 3px;
  font-size:12px;
  .user-name-or-image{
    height: 25px;
    width: 25px;
    border: 1px solid #3a3a3a;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    position: relative;
    top: -2px;
  }
  .username-in-wrapper{
    margin-inline-start: 4px;
  }
}

.assets-view-wrapper.list-view-mode {
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
  min-height: 0;
  height: var(--catalog-assets-height, calc(100vh - 185px)) !important;
  max-height: var(--catalog-assets-height, calc(100vh - 185px)) !important;
  background: $primary-background !important;
  color: $text-color !important;
}

.assets-view-wrapper.thumbnail-view-mode {
  display: inline-block !important;
  overflow: auto !important;
  white-space: nowrap !important;
}

.file-table-container,
.list-view-wrapper,
.metadata-table-scroll-wrapper {
  min-height: 0;
  width: 100%;
}

.file-table-container,
.list-view-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.assets-view-wrapper.thumbnail-view-mode .file-table-container {
  display: block !important;
  flex: unset !important;
  min-height: unset !important;
  overflow: visible !important;
}

.list-view-wrapper {
  overflow: visible !important;
  background: $primary-background !important;
}

.metadata-table-scroll-wrapper {
  flex: 1;
  overflow: auto !important;
  position: relative;
  background: $primary-background !important;
  scrollbar-gutter: stable;
}

.metadata-table-scroll-wrapper::-webkit-scrollbar-corner {
  background: $scrollbar-track-background !important;
}

.metadata-table-scroll-wrapper::-webkit-scrollbar {
  width: 11px;
  height: 12px !important;
}

.metadata-table-scroll-wrapper::-webkit-scrollbar-track {
  background: $scrollbar-track-background !important;
}

.metadata-table-scroll-wrapper::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background !important;
  border: 3px solid $scrollbar-track-background !important;
  border-radius: 10px;
}

.metadata-table-scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background !important;
}

.table-scroll thead {
  position: static !important;
}

.table-scroll tbody {
  overflow: visible !important;
}

.metadata-config-table {
  width: max-content !important;
  min-width: 100% !important;
  table-layout: fixed;
  border-collapse: separate !important;
  border-spacing: 0;
  background: $primary-background !important;
  color: $text-color !important;
}

.metadata-config-table th,
.metadata-config-table td {
  box-sizing: border-box;
  white-space: nowrap;
  background: $primary-background !important;
  color: $text-color !important;
  box-shadow: none !important;
}

.metadata-config-table thead th {
  position: sticky !important;
  top: 0 !important;
  z-index: 1 !important;
  height: 40px !important;
  padding: 0 12px !important;
  background: $primary-background !important;
  color: $dull-text-color !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  border-top: none !important;
  vertical-align: middle !important;
}

.metadata-config-table tbody td {
  padding: 8px 12px !important;
  border-bottom: none !important;
  vertical-align: top !important;
  font-size: 13px;
}

.metadata-config-table tbody tr:hover:not(.metadata-section-row) td {
  background: $bg-color-on-hover !important;
}

.metadata-config-table tbody tr.activeAsset td,
.metadata-config-table tbody tr.active-list-view.activeAsset td {
  background: $bg-color-on-hover !important;
  color: $active-blue !important;
}

.metadata-section-row,
.metadata-section-row td,
.metadata-section-row .text-left {
  background: $primary-background !important;
  color: $dull-text-color !important;
}

.metadata-section-row td {
  padding: 0 !important;
  border: none !important;
}

.asset-preview-col,
.metadata-config-table tbody td.asset-preview-col {
  text-align: center !important;
  vertical-align: top !important;
}

.metadata-config-table tbody td.asset-preview-col > div,
.metadata-config-table tbody td.asset-preview-col .asset-thumbnail-hw-set,
.metadata-config-table tbody td.asset-preview-col .thumbnail-hw-set {
  margin-left: auto !important;
  margin-right: auto !important;
  margin-inline: auto !important;
}

.metadata-header-cell,
.resizable-th {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  min-height: 38px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: $dull-text-color !important;
}

.slugname-header-cell,
.metadata-config-table th.metadata-multiline-th .metadata-header-cell,
.metadata-config-table th.metadata-multiline-th .metadata-multiline-header-cell {
  justify-content: flex-start !important;
  text-align: start !important;
}

.metadata-header-cell > span:first-child,
.resizable-th {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.metadata-resize-handle,
.resize-handle {
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-end: -5px;
  width: 10px !important;
  min-width: 10px !important;
  height: 100% !important;
  margin: 0 !important;
  cursor: col-resize;
  background: transparent !important;
  opacity: 0;
  z-index: 5;
  transition: opacity 0.15s ease;
}

.metadata-resize-handle::before,
.resize-handle::before {
  content: "";
  position: absolute;
  top: 8px;
  bottom: 8px;
  inset-inline-start: 4px;
  width: 1px;
  border-radius: 4px;
  background: $dull-text-color !important;
  opacity: 0;
  transition: background 0.15s ease, opacity 0.15s ease, width 0.15s ease;
}

.metadata-config-table thead th:hover .resize-handle,
.metadata-config-table .resize-handle:active {
  opacity: 1;
}

.metadata-config-table thead th:hover .resize-handle::before,
.metadata-config-table .resize-handle:active::before {
  opacity: 1;
}

.resize-handle:hover::before,
.metadata-config-table .resize-handle:active::before {
  width: 2px;
  background: $active-blue !important;
  box-shadow: 0 0 6px rgba(0, 123, 255, 0.45);
}

.metadata-config-table.resizing,
.metadata-config-table.resizing * {
  user-select: none !important;
  cursor: col-resize !important;
}

.slugname-list-cell {
  padding: 10px 16px !important;
  text-align: start !important;
  white-space: normal !important;
  word-break: normal !important;
  overflow-wrap: anywhere;
  line-height: 18px;
  vertical-align: middle !important;
}

.slugname-list-cell > div {
  width: 100%;
  min-width: 0;
}

.slugname-list-cell > div > div:first-child > div:first-child {
  display: flex !important;
  align-items: flex-start !important;
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.slugname-list-cell .svg-icons-display {
  flex: 0 0 22px;
  width: 22px !important;
  min-width: 22px !important;
  height: 22px !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}

.slugname-list-cell .svg-icons-display svg {
  width: 18px !important;
  height: 18px !important;
}

.slugname-list-cell .file-name-display-styles-in-list-view {
  position: static !important;
  display: inline-flex !important;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 3px;
  margin-inline-start: 0 !important;
  max-width: calc(100% - 32px) !important;
  min-width: 0;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 18px;
}

.slugname-list-cell .dynamic-slug-name {
  display: inline;
  min-width: 0;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 18px;
}

.slugname-list-cell .file-extension,
.slugname-list-cell .file-extension-thumbnail-view {
  margin-inline-start: 2px !important;
  color: $secondary-text-color !important;
  font-size: 12px;
}

.slugname-list-cell .description-alignment,
.slugname-list-cell .dull-the-text.comm-lengthy-value-styles {
  display: block;
  margin-inline-start: 32px;
  max-width: calc(100% - 32px);
  white-space: normal !important;
  overflow-wrap: anywhere;
  line-height: 17px;
  font-size: 12px;
}

.slugname-list-cell > div > .d-flex,
.slugname-list-cell .username-wrapper {
  margin-inline-start: 32px !important;
  max-width: calc(100% - 32px);
}

.slugname-list-cell .username-wrapper > div {
  gap: 4px;
  align-items: center !important;
}

.slugname-list-cell .username-in-wrapper {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.slugname-list-cell > div > .d-flex .dull-the-text.comm-lengthy-value-styles {
  margin-inline-start: 0 !important;
  max-width: 100% !important;
}

.slugname-tags-block,
.list-view-wrapper.dock-open-list-view .slugname-tags-block {
  position: relative !important;
  inset-inline-start: 0 !important;
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: flex-start !important;
  gap: 6px !important;
  width: calc(100% - 32px) !important;
  max-width: calc(100% - 32px) !important;
  min-width: 0 !important;
  margin: 6px 0 0 32px !important;
  overflow: visible !important;
  white-space: normal !important;
  max-height: none !important;
  box-sizing: border-box !important;
}

.slugname-tags-block > .d-flex,
.list-view-wrapper.dock-open-list-view .slugname-tags-block > .d-flex {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: flex-start !important;
  gap: 0 !important;
  min-width: 0 !important;
  max-width: 100% !important;
  margin: 0 !important;
}

.slugname-tags-block > .change-the-text-color,
.slugname-tags-block > .display-label,
.list-view-wrapper.dock-open-list-view .slugname-tags-block > .change-the-text-color,
.list-view-wrapper.dock-open-list-view .slugname-tags-block > .display-label {
  display: inline-flex !important;
  align-items: center !important;
  margin-inline-start: 0 !important;
  margin-top: 0 !important;
  width: auto !important;
  max-width: 100% !important;
  min-width: 0 !important;
  min-height: 22px !important;
  padding: 3px 9px !important;
  border-radius: 10px !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  word-break: break-word !important;
  overflow-wrap: anywhere !important;
  box-sizing: border-box !important;
}

.metadata-value-cell {
  vertical-align: middle !important;
  text-align: center !important;
  padding: 8px 12px !important;
  color: $text-color;
  font-size: 12px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
}

.metadata-display-value {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metadata-display-multiline,
.metadata-multiline-value {
  display: -webkit-box !important;
  white-space: pre-wrap !important;
  word-break: break-word !important;
  overflow-wrap: anywhere !important;
  overflow: hidden !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  max-height: 34px !important;
  line-height: 17px !important;
}

.metadata-multiline-value.expanded {
  display: block !important;
  -webkit-line-clamp: unset !important;
  max-height: none !important;
  overflow: visible !important;
}

.metadata-value-cell .metadata-display-chip {
  text-align: center !important;
}

.metadata-config-table th.metadata-multiline-th,
.metadata-config-table td.metadata-multiline-td,
.metadata-config-table td.metadata-multiline-td .metadata-multiline-value,
.metadata-config-table td.metadata-multiline-td .metadata-display-value,
.metadata-config-table td.metadata-multiline-td span {
  text-align: start !important;
}

.dock-metadata-kv-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 18px;
  row-gap: 5px;
  max-width: 100%;
  margin-top: 6px;
  font-size: 11px;
  line-height: 17px;
  color: $secondary-text-color;
}

.dock-metadata-kv-item {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 4px;
  flex: 0 1 auto;
  width: auto;
  min-width: 0;
  max-width: 360px;
}

.dock-metadata-key {
  flex: 0 0 auto;
  color: $dull-text-color;
  white-space: nowrap;
}

.dock-metadata-value {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 220px;
  color: $text-color;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.dock-metadata-separator {
  color: $dull-text-color;
  margin: 0 4px;
}

.dock-metadata-kv-item--multiline {
  flex: 1 1 100% !important;
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
}

.dock-metadata-value-wrapper {
  display: inline-flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  max-width: none;
}

.metadata-show-more-btn {
  display: inline-flex !important;
  width: fit-content !important;
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
  margin: 2px 0 0 0 !important;
  color: #a6a6a6 !important;
  font-size: 11px !important;
  line-height: 14px !important;
  cursor: pointer !important;
}

.metadata-show-more-btn:hover {
  text-decoration: underline !important;
}

.list-view-wrapper.dock-open-list-view {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  overflow: hidden !important;
}

.list-view-wrapper.dock-open-list-view .metadata-table-scroll-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.list-view-wrapper.dock-open-list-view .metadata-resize-handle,
.list-view-wrapper.dock-open-list-view .resize-handle {
  display: none !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table {
  display: block !important;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  table-layout: auto !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table colgroup {
  display: none !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table thead {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 2 !important;
  background: $primary-background !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table tbody {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table thead tr,
.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) {
  display: grid !important;
  grid-template-columns: 140px minmax(0, 1fr) !important;
  column-gap: 0 !important;
  align-items: stretch !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  height: auto !important;
  min-height: 40px !important;
  box-sizing: border-box !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table thead tr > th:nth-child(n + 3),
.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) > td:nth-child(n + 3) {
  display: none !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table thead tr > th,
.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) > td {
  display: block !important;
  width: auto !important;
  min-width: 0 !important;
  max-width: 100% !important;
  height: auto !important;
  box-sizing: border-box !important;
  overflow: visible !important;
  white-space: normal !important;
  resize: none !important;
  border: none !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) > td:nth-child(1) {
  grid-column: 1 !important;
  padding: 10px 8px !important;
  border-inline-end: none !important;
  display: flex !important;
  align-items: flex-start !important;
  justify-content: center !important;
  text-align: center !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) > td:nth-child(1) > div {
  margin: 0 auto !important;
  background: transparent !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) > td:nth-child(1) img,
.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) > td:nth-child(1) .thumbnail-view,
.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) > td:nth-child(1) .asset-thumbnail-hw-set,
.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) > td:nth-child(1) .thumbnail-hw-set {
  max-width: 104px !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) > td:nth-child(1) img {
  height: auto !important;
  max-height: 72px !important;
  object-fit: contain !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row) > td:nth-child(2) {
  grid-column: 2 !important;
  padding: 10px 12px !important;
  text-align: start !important;
  visibility: visible !important;
  opacity: 1 !important;
  border-bottom: none !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row):hover,
.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr:not(.metadata-section-row):hover > td {
  background: $bg-color-on-hover !important;
}

.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr.activeAsset,
.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr.active-list-view.activeAsset,
.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr.activeAsset > td,
.list-view-wrapper.dock-open-list-view .metadata-config-table tbody tr.active-list-view.activeAsset > td {
  background: $bg-color-on-hover !important;
  color: $active-blue !important;
}

.list-view-wrapper.dock-open-list-view .metadata-section-row,
.list-view-wrapper.dock-open-list-view .metadata-section-row td,
.list-view-wrapper.dock-open-list-view .metadata-section-row .text-left {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  background: $primary-background !important;
  border-bottom: none !important;
  box-sizing: border-box !important;
}

.list-view-wrapper.dock-open-list-view .slugname-list-cell .dock-metadata-kv-row {
  width: calc(100% - 26px) !important;
  max-width: calc(100% - 26px) !important;
  margin: 6px 0 0 26px !important;
  padding: 0 !important;
}

.list-view-wrapper.dock-open-list-view .slugname-list-cell .dock-metadata-separator {
  display: none !important;
}

.dock-metadata-separator{
  display: none !important;
}

.slugname-list-cell .transcript-content-wrapper,
.slugname-list-cell .multi-transcript-content-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  margin-inline-start: 0 !important;
  white-space: normal !important;
  overflow: visible !important;
}

.slugname-list-cell .multi-transcript-content-wrapper {
  display: flex !important;
  align-items: flex-start !important;
  margin-top: 11px !important;
  position: relative !important;
  flex-wrap: wrap !important;
}

.slugname-list-cell .multi-transcript-content-wrapper .transcript-list {
  display: inline-flex !important;
  width: 100% !important;
  margin-bottom: 4px !important;
  align-items: flex-start !important;
}

.slugname-list-cell .transcript-content-wrapper .secondary-dull-the-text,
.slugname-list-cell .multi-transcript-content-wrapper .secondary-dull-the-text,
.slugname-list-cell .transcript-content-wrapper .transcript-content-highlight,
.slugname-list-cell .multi-transcript-content-wrapper .transcript-content-highlight {
  display: inline !important;
  margin-inline-start: 0 !important;
  max-width: none !important;
  width: auto !important;
  white-space: pre-wrap !important;
  overflow: visible !important;
  overflow-wrap: normal !important;
  word-break: normal !important;
  line-height: normal !important;
  font-size: inherit !important;
}

.slugname-tags-block > .d-flex .change-the-text-color {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
}
.list-view-wrapper:not(.dock-open-list-view)
  .metadata-table-scroll-wrapper.no-configured-columns {
  overflow-x: hidden !important;
  width: 100% !important;
}

.list-view-wrapper:not(.dock-open-list-view)
  .metadata-table-scroll-wrapper.no-configured-columns
  .metadata-config-table {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  table-layout: fixed !important;
}

/* Override fixed px colgroup widths only when no configured columns */
.list-view-wrapper:not(.dock-open-list-view)
  .metadata-table-scroll-wrapper.no-configured-columns
  .metadata-config-table
  colgroup
  col:nth-child(1) {
  width: 12% !important;
}

.list-view-wrapper:not(.dock-open-list-view)
  .metadata-table-scroll-wrapper.no-configured-columns
  .metadata-config-table
  colgroup
  col:nth-child(2) {
  width: 42% !important;
}

.list-view-wrapper:not(.dock-open-list-view)
  .metadata-table-scroll-wrapper.no-configured-columns
  .metadata-config-table
  colgroup
  col:nth-child(3) {
  width: 15% !important;
}

.list-view-wrapper:not(.dock-open-list-view)
  .metadata-table-scroll-wrapper.no-configured-columns
  .metadata-config-table
  colgroup
  col:nth-child(4) {
  width: 15% !important;
}

.list-view-wrapper:not(.dock-open-list-view)
  .metadata-table-scroll-wrapper.no-configured-columns
  .metadata-config-table
  colgroup
  col:nth-child(5) {
  width: 16% !important;
}

.list-view-wrapper:not(.dock-open-list-view)
  .metadata-table-scroll-wrapper.no-configured-columns
  .metadata-config-table
  thead th:nth-child(5),
.list-view-wrapper:not(.dock-open-list-view)
  .metadata-table-scroll-wrapper.no-configured-columns
  .metadata-config-table
  tbody tr:not(.metadata-section-row) td:nth-child(5) {
  text-align: end !important;
  white-space: nowrap !important;
  overflow: visible !important;
  padding-inline-end: 22px !important;
}

.catalog-parent-path-text{
  margin-inline-start: 0px !important;
}
.catalog-dock-metadata-row{
  margin: 6px 0 0 0px !important;
}
.catalog-footer-safe {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
  min-height: 40px !important;
  height: auto !important;
  flex-shrink: 0 !important;
  padding: 0 8px !important;
  gap: 8px !important;
  background: $primary-background !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
  position: relative !important;
  z-index: 20 !important;
}

.catalog-footer-selected-safe {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  max-width: none !important;
  display: inline-flex !important;
  align-items: center !important;
  overflow: hidden !important;
}

.catalog-footer-selected-item {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  max-width: 100% !important;
  display: inline-flex !important;
  align-items: center !important;
  overflow: hidden !important;
  line-height: 28px !important;
}

.catalog-footer-selected-label {
  flex: 0 0 auto !important;
  color: #777777 !important;
  padding-inline-end: 4px !important;
  white-space: nowrap !important;
}

.catalog-footer-selected-value {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  max-width: 100% !important;
  display: inline-block !important;
  color: $text-color !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: start !important;
}

.catalog-footer-pagination-safe {
  flex: 0 0 auto !important;
  min-width: 0 !important;
  max-width: 100% !important;
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 6px !important;
  margin-inline-start: auto !important;
  overflow: visible !important;
}

.catalog-pagination-count {
  order: 1 !important;
  flex: 0 0 auto !important;
  width: auto !important;
  color: $secondary-text-color !important;
  font-size: 12px !important;
  line-height: 28px !important;
  white-space: nowrap !important;
  margin: 0 !important;
  padding: 0 !important;
  text-align: end !important;
}

.catalog-pagination-controls-row {
  order: 2 !important;
  flex: 0 0 auto !important;
  min-width: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 4px !important;
  height: 28px !important;
}

::v-deep .catalog-footer-pagination-safe .VuePagination {
  display: inline-flex !important;
  align-items: center !important;
  margin: 0 !important;
  width: auto !important;
}

::v-deep .catalog-footer-pagination-safe .VuePagination__count {
  display: none !important;
}

::v-deep .catalog-footer-pagination-safe .pagination,
::v-deep .catalog-footer-pagination-safe .VuePagination__pagination {
  display: inline-flex !important;
  flex-wrap: nowrap !important;
  margin: 0 !important;
  float: none !important;
}

::v-deep .catalog-footer-pagination-safe.single-page-pagination .pagination,
::v-deep .catalog-footer-pagination-safe.single-page-pagination .VuePagination__pagination {
  display: none !important;
}

.catalog-footer-safe .customise-pagination-option {
  flex: 0 0 26px !important;
  width: 26px !important;
  min-width: 26px !important;
  height: 28px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  overflow: visible !important;
  z-index: 30 !important;
}

.catalog-footer-safe .customise-pagination-option > a {
  height: 28px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Only when BOTH metadata dock and asset details panel are open */
.catalog-footer-safe.both-panels-open-footer {
  align-items: flex-start !important;
  min-height: 50px !important;
}

.catalog-footer-safe.both-panels-open-footer .catalog-footer-selected-safe {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  max-width: calc(100% - 170px) !important;
  align-self: flex-start !important;
  padding-top: 2px !important;
  overflow: hidden !important;
}

.catalog-footer-safe.both-panels-open-footer .catalog-footer-pagination-safe {
  flex: 0 0 auto !important;
  max-width: none !important;
  display: inline-flex !important;
  flex-direction: column !important;
  align-items: flex-end !important;
  justify-content: flex-start !important;
  gap: 0 !important;
  margin-inline-start: 6px !important;
  overflow: visible !important;
}

.catalog-footer-safe.both-panels-open-footer .catalog-pagination-controls-row {
  order: 1 !important;
  height: 28px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 4px !important;
}

.catalog-footer-safe.both-panels-open-footer .catalog-pagination-count {
  order: 2 !important;
  width: 100% !important;
  text-align: end !important;
  line-height: 16px !important;
  margin-top: 1px !important;
  white-space: nowrap !important;
}

/* If pagination is hidden, keep 3 dots beside count */
.catalog-footer-safe.both-panels-open-footer
  .catalog-footer-pagination-safe.single-page-pagination {
  flex-direction: row !important;
  align-items: center !important;
  gap: 6px !important;
}

.catalog-footer-safe.both-panels-open-footer
  .catalog-footer-pagination-safe.single-page-pagination
  .catalog-pagination-count {
  order: 1 !important;
  width: auto !important;
  line-height: 28px !important;
  margin-top: 0 !important;
}

.catalog-footer-safe.both-panels-open-footer
  .catalog-footer-pagination-safe.single-page-pagination
  .catalog-pagination-controls-row {
  order: 2 !important;
}
/* Align mark-for-delete icon properly in list view catalog preview */
.list-view-wrapper.dock-open-list-view
  .metadata-config-table
  tbody
  tr:not(.metadata-section-row)
  > td:nth-child(1)
  > div {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 48px !important;
  margin: 0 auto !important;
}

/* Do not allow folder/card to shift when catalog is marked for delete */
.list-view-wrapper.dock-open-list-view
  .metadata-config-table
  tbody
  tr:not(.metadata-section-row)
  > td:nth-child(1)
  .card {
  inset-inline-start: auto !important;
  margin: 0 auto !important;
}

/* Keep folder/svg icon centered */
.list-view-wrapper.dock-open-list-view
  .metadata-config-table
  tbody
  tr:not(.metadata-section-row)
  > td:nth-child(1)
  svg.bi-folder-fill,
.list-view-wrapper.dock-open-list-view
  .metadata-config-table
  tbody
  tr:not(.metadata-section-row)
  > td:nth-child(1)
  svg.bi-collection-fill {
  position: static !important;
  inset-inline-start: auto !important;
  inset-inline-end: auto !important;
  margin: 0 auto !important;
}

/* Center red mark-for-delete icon over preview */
.list-view-wrapper.dock-open-list-view
  .metadata-config-table
  tbody
  tr:not(.metadata-section-row)
  > td:nth-child(1)
  img[alt="markfordelete"] {
  position: absolute !important;
  width: 20px !important;
  height: 20px !important;
  top: 50% !important;
  bottom: auto !important;
  inset-inline-start: 50% !important;
  inset-inline-end: auto !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
  z-index: 3 !important;
}

.metadata-config-table td.metadata-multiline-td,
.metadata-config-table td.metadata-multiline-td > span,
.metadata-config-table td.metadata-multiline-td > div,
.metadata-config-table td.metadata-multiline-td .metadata-display-value,
.metadata-config-table td.metadata-multiline-td .metadata-multiline-value {
  text-align: start !important;
  justify-content: flex-start !important;
}

.metadata-config-table td.metadata-multiline-td .metadata-multiline-value {
  width: 100% !important;
}

.catalog-footer-safe {
  overflow: visible !important;
  z-index: 100 !important;
}

.catalog-footer-selected-safe,
.catalog-footer-selected-item,
.catalog-footer-selected-value {
  overflow: hidden !important;
}

/* Keep pagination 3 dots visible and clickable */
.catalog-footer-safe .customise-pagination-option {
  overflow: visible !important;
  position: relative !important;
  z-index: 200 !important;
}

.catalog-footer-safe .customise-pagination-option .dropdown-menu {
  position: absolute !important;
  top: auto !important;
  bottom: 30px !important;
  inset-inline-end: 0 !important;
  inset-inline-start: auto !important;
  z-index: 9999 !important;
  min-width: 150px !important;
}

.assets-view-wrapper.list-view-mode,
.file-table-container,
.list-view-wrapper,
.metadata-table-scroll-wrapper {
  position: relative !important;
}

.standard-panel-top-nav .more-actions-icon > .dropdown-menu {
  top: calc(100% + 34px) !important;
  inset-inline-end: 0 !important;
  inset-inline-start: auto !important;
  z-index: 9999 !important;
}

.metadata-table-scroll-wrapper.no-configured-columns .resize-handle,
.metadata-table-scroll-wrapper.no-configured-columns .metadata-resize-handle {
  display: none !important;
  pointer-events: none !important;
}


/* Show text cursor only in information cells */
.metadata-config-table tbody tr.active-list-view td:not(.asset-preview-col),
.metadata-config-table tbody tr.active-list-view td:not(.asset-preview-col) *:not(button):not(input):not(svg):not(path):not(img) {
  user-select: text !important;
  -webkit-user-select: text !important;
  cursor: text !important;
}

.asset-preview-col,
.asset-preview-col *,
.asset-thumbnail,
.asset-thumbnail *,
.asset-thumbnail-hw-set,
.asset-thumbnail-hw-set *,
.thumbnail-view,
.thumbnail-view *,
.thumbnail-hw-set,
.thumbnail-hw-set * {
  user-select: none !important;
  -webkit-user-select: none !important;
  cursor: default !important;
}

/* Action icons should stay clickable */
.asset-preview-col .shortcut-actions-type-icons-wrapper,
.asset-preview-col .shortcut-actions-type-icons-wrapper *,
.asset-thumbnail .shortcut-actions-type-icons-wrapper,
.asset-thumbnail .shortcut-actions-type-icons-wrapper *,
.asset-thumbnail-hw-set .shortcut-actions-type-icons-wrapper,
.asset-thumbnail-hw-set .shortcut-actions-type-icons-wrapper * {
  cursor: pointer !important;
}

::v-deep .catalog-list-main-context-menu {
  position: fixed !important;
  max-height: calc(100vh - 16px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  z-index: 99990 !important;
}

::v-deep .catalog-list-sub-context-menu {
  position: fixed !important;
  max-height: calc(100vh - 16px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;

  z-index: 100000 !important;
}

.dock-open-list-view .catalog-cover-image {
  width: 39px !important;
  height: 40px !important;
  max-width: 39px !important;
  max-height: 40px !important;
  object-fit: cover !important;
}

::v-deep div[data-drag-box-component] {
  z-index: 100;
}

/* Apply the special positioning only to list view */
.assets-view-wrapper.list-view-mode {
  ::v-deep div[data-drag-box-component] {
    position: fixed !important;
    z-index: 999999 !important;
    pointer-events: none !important;
  }
}
</style>